import { useState, useEffect } from "react";
import FairePart from "./FairePart";
import Chat from "./Chat";
import { CoupleAvis, ProAvis } from "./Avis";
import AdminDashboard from "./Admin";
import { supabase } from "./lib/supabase";
import "./App.css";
import logoImg from "./logo.png.png";

const ADMIN_EMAIL = "beaumariage@wedyra.fr";

const CATEGORIES = [
  { slug:"lieu-reception", nom:"Lieu de réception", icone:"🏰" },
  { slug:"traiteur", nom:"Traiteur", icone:"🍽️" },
  { slug:"photographe", nom:"Photographe", icone:"📸" },
  { slug:"videaste", nom:"Vidéaste", icone:"🎬" },
  { slug:"dj-musique", nom:"DJ / Musique", icone:"🎵" },
  { slug:"fleuriste", nom:"Fleuriste", icone:"💐" },
  { slug:"wedding-planner", nom:"Wedding Planner", icone:"📋" },
  { slug:"decoration", nom:"Décoration", icone:"🎀" },
  { slug:"patissier-gateau", nom:"Pâtissier / Gâteau", icone:"🎂" },
  { slug:"coiffure-maquillage", nom:"Coiffure & Maquillage", icone:"💄" },
];

const ETAPES = [
  { id:1, categorie:"Administratif", titre:"Choisir la date et le lieu de la mairie", delai:"12 mois avant", fait:true },
  { id:2, categorie:"Lieu", titre:"Visiter et réserver la salle de réception", delai:"12 mois avant", fait:true },
  { id:3, categorie:"Photo/Vidéo", titre:"Réserver le photographe", delai:"10 mois avant", fait:false },
  { id:4, categorie:"Traiteur", titre:"Déguster et choisir le traiteur", delai:"10 mois avant", fait:false },
  { id:5, categorie:"Tenue", titre:"Essayages robe de mariée", delai:"9 mois avant", fait:false },
  { id:6, categorie:"Animation", titre:"Réserver le DJ ou groupe musical", delai:"8 mois avant", fait:false },
  { id:7, categorie:"Invités", titre:"Envoyer les faire-parts", delai:"6 mois avant", fait:false },
  { id:8, categorie:"Fleurs", titre:"Rencontrer le fleuriste", delai:"6 mois avant", fait:false },
  { id:9, categorie:"Beauté", titre:"Essai coiffure et maquillage", delai:"3 mois avant", fait:false },
  { id:10, categorie:"Organisation", titre:"Finaliser le plan de table", delai:"1 mois avant", fait:false },
];

const BUDGET_INIT = [
  { id:1, categorie:"Lieu", label:"Salle de réception", budget:0, depense:0, statut:"à réserver" },
  { id:2, categorie:"Photo/Vidéo", label:"Photographe", budget:0, depense:0, statut:"à réserver" },
  { id:3, categorie:"Traiteur", label:"Repas & boissons", budget:0, depense:0, statut:"à réserver" },
  { id:4, categorie:"Tenue", label:"Robe de mariée", budget:0, depense:0, statut:"à réserver" },
  { id:5, categorie:"Animation", label:"DJ", budget:0, depense:0, statut:"à réserver" },
  { id:6, categorie:"Fleurs", label:"Décoration florale", budget:0, depense:0, statut:"à réserver" },
  { id:7, categorie:"Invitations", label:"Faire-parts", budget:0, depense:0, statut:"à réserver" },
  { id:8, categorie:"Voyage", label:"Lune de miel", budget:0, depense:0, statut:"à réserver" },
];

const CAT_COLORS = { "Administratif":"#8B7ED8","Lieu":"#E8956D","Photo/Vidéo":"#D4796A","Traiteur":"#7BAF8E","Tenue":"#C4956A","Animation":"#6A9BB5","Invités":"#B5647A","Fleurs":"#D4839A","Beauté":"#D4847A","Organisation":"#8B7ED8","Voyage":"#9B6B7A","Autre":"#999" };

const RSVP_OPTIONS = [
  { key:"present", emoji:"✅", label:"Je serai là !", color:"#4E8C65", bg:"#EBF5EF" },
  { key:"present_deux", emoji:"👫", label:"Nous serons présents !", color:"#4A729A", bg:"#EBF2F7" },
  { key:"celebrer", emoji:"🥂", label:"Je viendrai fêter ça !", color:"#B8803A", bg:"#FBF0E3" },
  { key:"absent", emoji:"💔", label:"Avec vous en pensée", color:"#9B6B7A", bg:"#FAF0F3" },
  { key:"plus_tard", emoji:"⏳", label:"Je confirme bientôt", color:"#7A5A65", bg:"#F5F0F2" },
];

const LIGHT = { primary:"#B5647A", primaryLight:"#D4839A", primaryBg:"#FAF0F3", primaryBorder:"#EBC5CE", page:"#FDFAF9", card:"#FFFFFF", cardBorder:"#F0E8EC", header:"#FFFFFF", headerBorder:"#F0E8EC", text:"#2C1A22", textMuted:"#7A5A65", textLight:"#B8A0A8", green:"#4E8C65", greenBg:"#EBF5EF", blue:"#4A729A", blueBg:"#EBF2F7", amber:"#B8803A", amberBg:"#FBF0E3", rowHover:"#FAF0F3", progressBg:"#F0E5E8", notesBg:"#FAF0F3", chip:"#FAF0F3", chipText:"#B5647A" };
const DARK = { primary:"#D4839A", primaryLight:"#B5647A", primaryBg:"#2A1520", primaryBorder:"#5A2535", page:"#180E12", card:"#221318", cardBorder:"#3A2028", header:"#180E12", headerBorder:"#3A2028", text:"#F5EAF0", textMuted:"#C4A0B0", textLight:"#7A5565", green:"#6DB585", greenBg:"#0F2A1A", blue:"#7AAABF", blueBg:"#0F1E2A", amber:"#D4A060", amberBg:"#2A1C0A", rowHover:"#2A1520", progressBg:"#3A2028", notesBg:"#2A1520", chip:"#2A1520", chipText:"#D4839A" };

const Logo = ({ height=44, dark=false }) => (
  <img src={logoImg} alt="Wedyra" className="logo" style={{ height, width:"auto", ...(dark ? { background:"rgba(255,255,255,0.9)", padding:"2px 6px", borderRadius:8 } : {}) }}/>
);

const Bar = ({ pct, color, bg="#F0E5E8", h=5 }) => <div style={{height:h,borderRadius:h/2,background:bg}}><div style={{height:h,borderRadius:h/2,background:color,width:`${Math.min(100,pct||0)}%`,transition:"width 0.5s"}}/></div>;


// ============================================================
// WELCOME
// ============================================================
function Welcome({ onLogin }) {
  const [show, setShow] = useState(false);
  const [role, setRole] = useState("couple");
  const [isLogin, setIsLogin] = useState(false);
  const [form, setForm] = useState({ prenom:"", partenaire:"", date:"", email:"", password:"", nom_entreprise:"", telephone:"", description:"", ville:"" });
  const [resetMode, setResetMode] = useState(false);
  const [resetSent, setResetSent] = useState(false);
  const inp = { width:"100%", padding:"11px 14px", borderRadius:10, border:"1.5px solid #F0E8EC", fontFamily:"'DM Sans',sans-serif", fontSize:14, outline:"none", color:"#2C1A22", boxSizing:"border-box" };

  const handleReset = async () => {
    const email = form.email.trim().toLowerCase();
    if (!email) { alert('Entrez votre email.'); return; }
    const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo: window.location.origin });
    if (error) { alert(error.message); return; }
    setResetSent(true);
  };

  const handleSubmit = async () => {
    if (!form.email || !form.password) { alert('Email et mot de passe requis.'); return; }
    if (!isLogin && form.password.length < 8) { alert('Le mot de passe doit contenir au moins 8 caractères.'); return; }
    const email = form.email.trim().toLowerCase();
    const password = form.password;
    try {
      if (isLogin) {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) { alert(error.message); return; }
        const userId = data.user.id;
        const userEmail = (data.user.email || email).toLowerCase();
        if (userEmail === ADMIN_EMAIL) {
          onLogin({ id: userId, nom: "Admin", role: "admin", email: userEmail });
          return;
        }
        if (role === 'couple') {
          const { data: profile } = await supabase.from('couples').select('*').eq('user_id', userId).single();
          if (!profile) { alert('Profil introuvable. Veuillez vous inscrire.'); return; }
          onLogin({ id:profile.id, nom:`${profile.prenom1} & ${profile.prenom2}`, date:profile.date_mariage, role:'couple', ville:profile.ville });
        } else {
          const { data: profile } = await supabase.from('prestataires').select('*').eq('user_id', userId).single();
          if (!profile) { alert('Profil introuvable. Veuillez vous inscrire.'); return; }
          onLogin({ id:profile.id, nom:profile.nom_entreprise, role:'pro', data:profile });
        }
      } else {
        const { data, error } = await supabase.auth.signUp({ email, password });
        if (error) { alert(error.message); return; }
        const userId = data.user.id;
        // Créer le profil immédiatement (avant confirmation email)
        if (role === 'couple') {
          const { error: pErr } = await supabase.from('couples').insert({
            user_id:userId, email, prenom1:form.prenom||'Prénom 1', prenom2:form.partenaire||'Prénom 2',
            date_mariage:form.date||null, ville:form.ville||null
          });
          if (pErr) { alert(pErr.message); return; }
        } else {
          const slug = (form.nom_entreprise||'pro').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[^a-z0-9]+/g,'-');
          const { error: pErr } = await supabase.from('prestataires').insert({
            user_id:userId, nom_entreprise:form.nom_entreprise||'Mon entreprise', slug, email,
            description:form.description||'', ville:form.ville||'', telephone:form.telephone||''
          });
          if (pErr) { alert(pErr.message); return; }
        }
        if (!data.session) {
          alert('Un email de confirmation a été envoyé. Vérifiez votre boîte mail puis connectez-vous.');
          setIsLogin(true);
          return;
        }
        // Si confirmation désactivée : charger et connecter directement
        if (role === 'couple') {
          const { data: profile } = await supabase.from('couples').select('*').eq('user_id', userId).single();
          if (profile) onLogin({ id:profile.id, nom:`${profile.prenom1} & ${profile.prenom2}`, date:profile.date_mariage, role:'couple', ville:profile.ville });
        } else {
          const { data: profile } = await supabase.from('prestataires').select('*').eq('user_id', userId).single();
          if (profile) onLogin({ id:profile.id, nom:profile.nom_entreprise, role:'pro', data:profile });
        }
      }
    } catch {
      alert('Une erreur est survenue. Veuillez réessayer.');
    }
  }

  return (
    <div style={{ minHeight:"100vh", background:"#FDFAF9", fontFamily:"'DM Sans',sans-serif" }}>
      <header className="header" style={{ position:"sticky", top:0, zIndex:10 }}>
        <div className="header-left">
          <button className="logo-link"><Logo height={96}/></button>
        </div>
        <div className="header-right">
          <button className="text-btn" onClick={()=>{setShow(true);setIsLogin(true);setRole("couple");}}>Se connecter</button>
          <button className="pill-btn" onClick={()=>{setShow(true);setIsLogin(false);setRole("couple");}}>Créer mon espace →</button>
        </div>
      </header>
      <div className="hero-grid">
        <div className="fade-in">
          <div style={{ display:"inline-flex", alignItems:"center", gap:8, background:"#FAF0F3", border:"1px solid #EBC5CE", borderRadius:100, padding:"6px 16px", fontSize:12, fontWeight:600, color:"#B5647A", letterSpacing:"1px", marginBottom:24 }}>🌸 Couples & Professionnels</div>
          <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:"clamp(34px,4vw,52px)", fontWeight:400, color:"#2C1A22", lineHeight:1.15, marginBottom:20 }}>Votre mariage,<br/><em style={{ color:"#B5647A" }}>organisé</em> avec soin</h1>
          <p style={{ fontSize:16, color:"#7A5A65", lineHeight:1.7, marginBottom:36 }}>Wedyra connecte les futurs mariés avec les meilleurs prestataires. Checklist, budget, matching IA, faire-parts animés et RSVP.</p>
          <div style={{ display:"flex", gap:14, flexWrap:"wrap" }}>
            <button onClick={()=>{setShow(true);setIsLogin(false);setRole("couple");}} style={{ padding:"14px 30px", borderRadius:14, border:"none", background:"#B5647A", color:"white", fontSize:15, fontWeight:600, cursor:"pointer" }}>Je suis un couple →</button>
            <button onClick={()=>{setShow(true);setIsLogin(false);setRole("pro");}} style={{ padding:"14px 30px", borderRadius:14, border:"1.5px solid #B5647A", background:"transparent", color:"#B5647A", fontSize:15, fontWeight:600, cursor:"pointer" }}>Je suis prestataire →</button>
          </div>
          <button onClick={()=>onLogin({nom:"Sophie & Nicolas",date:"2026-07-15",role:"couple"})} style={{ color:"#B8A0A8", fontSize:13, background:"none", border:"none", cursor:"pointer", marginTop:16, display:"block" }}>Voir la démo →</button>
        </div>
        <div className="fade-in hero-cards" style={{ display:"grid", gap:14 }}>
          {[{icon:"🌸",label:"Checklist",val:"10 étapes guidées",bg:"#FAF0F3"},{icon:"💰",label:"Budget temps réel",val:"Éditable au clic",bg:"#FBF0E3"},{icon:"✦",label:"Matching IA",val:"Top prestataires pour vous",bg:"#EBF5EF"},{icon:"💌",label:"Faire-parts animés",val:"IA + RSVP interactif",bg:"#FAF0F3"}].map((c,i)=>(
            <div key={i} style={{ background:"white", border:"1px solid #F0E8EC", borderRadius:14, padding:"16px 20px", display:"flex", alignItems:"center", gap:14 }}>
              <div style={{ width:42, height:42, borderRadius:12, background:c.bg, display:"flex", alignItems:"center", justifyContent:"center", fontSize:18, flexShrink:0 }}>{c.icon}</div>
              <div><div style={{ fontSize:12, color:"#B8A0A8", marginBottom:2 }}>{c.label}</div><div style={{ fontSize:15, fontWeight:600, color:"#2C1A22" }}>{c.val}</div></div>
            </div>
          ))}
        </div>
      </div>
      {show && <div onClick={e=>e.target===e.currentTarget&&setShow(false)} style={{ position:"fixed", inset:0, background:"rgba(44,26,34,0.4)", zIndex:100, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
        <div className="fade-in" style={{ background:"white", borderRadius:24, padding:"clamp(20px,5vw,36px)", maxWidth:"min(95vw,440px)", width:"100%", position:"relative", maxHeight:"90vh", overflowY:"auto" }}>
          <button onClick={()=>setShow(false)} style={{ position:"absolute", top:14, right:18, background:"none", border:"none", fontSize:22, cursor:"pointer", color:"#B8A0A8" }}>×</button>
          <div style={{ textAlign:"center", marginBottom:16 }}><Logo height={112}/></div>
          {resetMode ? (
            resetSent ? (
              <div style={{textAlign:"center",padding:"20px 0"}}>
                <div style={{fontSize:40,marginBottom:12}}>📬</div>
                <p style={{fontSize:15,fontWeight:600,color:"#2C1A22",marginBottom:8}}>Email envoyé !</p>
                <p style={{fontSize:13,color:"#7A5A65",marginBottom:24}}>Vérifiez votre boîte mail et cliquez sur le lien pour réinitialiser votre mot de passe.</p>
                <button onClick={()=>{setResetMode(false);setResetSent(false);}} style={{color:"#B5647A",background:"none",border:"none",cursor:"pointer",fontSize:13,fontWeight:500}}>← Retour à la connexion</button>
              </div>
            ) : (
              <>
                <h3 style={{fontFamily:"'Playfair Display',serif",fontSize:22,textAlign:"center",marginBottom:6,color:"#2C1A22"}}>Mot de passe oublié</h3>
                <p style={{fontSize:12,color:"#7A5A65",textAlign:"center",marginBottom:22}}>Entrez votre email pour recevoir un lien de réinitialisation.</p>
                <div style={{marginBottom:18}}><div style={{fontSize:12,fontWeight:600,color:"#2C1A22",marginBottom:5}}>Email</div><input type="email" value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} placeholder="contact@email.fr" style={inp} onKeyDown={e=>e.key==="Enter"&&handleReset()}/></div>
                <button onClick={handleReset} style={{width:"100%",padding:"14px",background:"#B5647A",color:"white",border:"none",borderRadius:12,fontSize:15,fontWeight:600,cursor:"pointer",marginBottom:12}}>Envoyer le lien →</button>
                <p style={{fontSize:13,color:"#B8A0A8",textAlign:"center"}}><button onClick={()=>setResetMode(false)} style={{color:"#B5647A",background:"none",border:"none",cursor:"pointer",fontSize:13,fontWeight:500}}>← Retour à la connexion</button></p>
              </>
            )
          ) : (
            <>
              <div style={{ display:"flex", background:"#FAF0F3", borderRadius:100, padding:3, marginBottom:20 }}>
                {[{k:"couple",l:"👫 Couple"},{k:"pro",l:"🏢 Prestataire"}].map(r=><button key={r.k} onClick={()=>setRole(r.k)} style={{ flex:1, padding:"8px", borderRadius:100, border:"none", fontSize:13, fontWeight:role===r.k?600:400, background:role===r.k?"#B5647A":"transparent", color:role===r.k?"#fff":"#7A5A65", cursor:"pointer" }}>{r.l}</button>)}
              </div>
              <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:22, textAlign:"center", marginBottom:6, color:"#2C1A22" }}>{isLogin?"Bon retour !":role==="couple"?"Créer mon espace":"Rejoindre en tant que pro"}</h3>
              <p style={{ fontSize:12, color:"#7A5A65", textAlign:"center", marginBottom:22 }}>{isLogin?"Connectez-vous":"Inscription gratuite"}</p>
              {!isLogin && role==="couple" && <>
                <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:10,marginBottom:12}}>
                  <div><div style={{fontSize:12,fontWeight:600,color:"#2C1A22",marginBottom:5}}>Votre prénom</div><input value={form.prenom} onChange={e=>setForm(f=>({...f,prenom:e.target.value}))} placeholder="Marie" style={inp}/></div>
                  <div><div style={{fontSize:12,fontWeight:600,color:"#2C1A22",marginBottom:5}}>Partenaire</div><input value={form.partenaire} onChange={e=>setForm(f=>({...f,partenaire:e.target.value}))} placeholder="Pierre" style={inp}/></div>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:10,marginBottom:12}}>
                  <div><div style={{fontSize:12,fontWeight:600,color:"#2C1A22",marginBottom:5}}>Date</div><input type="date" value={form.date} onChange={e=>setForm(f=>({...f,date:e.target.value}))} style={inp}/></div>
                  <div><div style={{fontSize:12,fontWeight:600,color:"#2C1A22",marginBottom:5}}>Ville</div><input value={form.ville} onChange={e=>setForm(f=>({...f,ville:e.target.value}))} placeholder="Strasbourg" style={inp}/></div>
                </div>
              </>}
              {!isLogin && role==="pro" && <>
                <div style={{marginBottom:12}}><div style={{fontSize:12,fontWeight:600,color:"#2C1A22",marginBottom:5}}>Nom de l'entreprise</div><input value={form.nom_entreprise} onChange={e=>setForm(f=>({...f,nom_entreprise:e.target.value}))} placeholder="Studio Photo" style={inp}/></div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:10,marginBottom:12}}>
                  <div><div style={{fontSize:12,fontWeight:600,color:"#2C1A22",marginBottom:5}}>Ville</div><input value={form.ville} onChange={e=>setForm(f=>({...f,ville:e.target.value}))} placeholder="Strasbourg" style={inp}/></div>
                  <div><div style={{fontSize:12,fontWeight:600,color:"#2C1A22",marginBottom:5}}>Téléphone</div><input value={form.telephone} onChange={e=>setForm(f=>({...f,telephone:e.target.value}))} placeholder="06..." style={inp}/></div>
                </div>
                <div style={{marginBottom:12}}><div style={{fontSize:12,fontWeight:600,color:"#2C1A22",marginBottom:5}}>Description</div><input value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))} placeholder="Photographe mariage..." style={inp}/></div>
              </>}
              <div style={{marginBottom:12}}><div style={{fontSize:12,fontWeight:600,color:"#2C1A22",marginBottom:5}}>Email</div><input type="email" value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} placeholder="contact@email.fr" style={inp}/></div>
              <div style={{marginBottom:isLogin?6:18}}><div style={{fontSize:12,fontWeight:600,color:"#2C1A22",marginBottom:5}}>Mot de passe{!isLogin&&<span style={{color:"#B8A0A8",fontWeight:400}}> (8 caractères min.)</span>}</div><input type="password" value={form.password} onChange={e=>setForm(f=>({...f,password:e.target.value}))} placeholder="••••••••" style={inp} onKeyDown={e=>e.key==="Enter"&&handleSubmit()}/></div>
              <button onClick={handleSubmit} style={{ width:"100%", padding:"14px", background:"#B5647A", color:"white", border:"none", borderRadius:12, fontSize:15, fontWeight:600, cursor:"pointer", marginBottom:12 }}>{isLogin?"Se connecter →":"Créer mon espace →"}</button>
              <p style={{ fontSize:13, color:"#B8A0A8", textAlign:"center" }}>{isLogin?"Pas de compte ? ":"Déjà un compte ? "}<button onClick={()=>setIsLogin(!isLogin)} style={{color:"#B5647A",background:"none",border:"none",cursor:"pointer",fontSize:13,fontWeight:500}}>{isLogin?"S'inscrire":"Se connecter"}</button></p>
              {isLogin && <button onClick={async () => {
                const email = form.email?.trim();
                if (!email) { alert("Entrez votre email d'abord."); return; }
                const { error } = await supabase.auth.resetPasswordForEmail(email, {
                  redirectTo: "https://www.wedyra.fr"
                });
                if (error) alert(error.message);
                else alert("Un email de réinitialisation a été envoyé à " + email);
              }} style={{
                color: "#B5647A", background: "none", border: "none",
                cursor: "pointer", fontSize: 12, marginTop: 8, display: "block",
                textAlign: "center", width: "100%"
              }}>
                Mot de passe oublié ?
              </button>}
            </>
          )}
        </div>
      </div>}
    </div>
  );
}

// ============================================================
// PROFIL PRESTATAIRE MODAL
// ============================================================
function ProfilModal({ presta, C, onClose, onContact, onCancel, contacted }) {
  if(!presta) return null;
  return (
    <div onClick={e=>e.target===e.currentTarget&&onClose()} style={{ position:"fixed", inset:0, background:"rgba(44,26,34,0.5)", zIndex:200, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div className="fade-in" style={{ background:C.card, borderRadius:24, padding:0, maxWidth:"min(95vw,540px)", width:"100%", position:"relative", overflow:"hidden", maxHeight:"90vh", overflowY:"auto" }}>
        {/* Header image area */}
        <div style={{ height:140, background:`linear-gradient(135deg, ${C.primaryBg}, ${C.primaryBorder})`, display:"flex", alignItems:"center", justifyContent:"center", position:"relative" }}>
          <div style={{ fontSize:56 }}>{presta.matchCats?.[0]==="Photographe"?"📸":presta.matchCats?.[0]==="DJ / Musique"?"🎵":presta.matchCats?.[0]==="Fleuriste"?"💐":presta.matchCats?.[0]==="Traiteur"?"🍽️":presta.matchCats?.[0]==="Lieu de réception"?"🏰":"🌸"}</div>
          {presta.is_premium && <span style={{ position:"absolute", top:12, right:12, fontSize:10, background:C.amberBg, color:C.amber, padding:"3px 10px", borderRadius:100, fontWeight:600 }}>⭐ Premium</span>}
          <button onClick={onClose} style={{ position:"absolute", top:12, left:12, width:32, height:32, borderRadius:"50%", background:"rgba(255,255,255,0.8)", border:"none", fontSize:16, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}>×</button>
        </div>
        {/* Body */}
        <div style={{ padding:"24px 28px 28px" }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:16 }}>
            <div>
              <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:24, color:C.text, marginBottom:4 }}>{presta.nom_entreprise}</h2>
              <div style={{ fontSize:13, color:C.textLight }}>📍 {presta.ville||"Alsace"}</div>
            </div>
            <div style={{ textAlign:"right" }}>
              <div style={{ fontSize:16, fontWeight:700, color:C.text }}>⭐ {presta.note_moyenne||"N/A"}</div>
              <div style={{ fontSize:12, color:C.textLight }}>{presta.nb_avis||0} avis</div>
            </div>
          </div>

          {/* Categories */}
          <div style={{ display:"flex", gap:6, marginBottom:16, flexWrap:"wrap" }}>
            {(presta.matchCats||[]).map((c,i)=><span key={i} style={{ fontSize:11, padding:"4px 12px", borderRadius:100, background:C.primaryBg, color:C.primary, fontWeight:500 }}>{c}</span>)}
          </div>

          {/* Description */}
          <div style={{ background:C.notesBg, borderRadius:14, padding:"16px 18px", marginBottom:16 }}>
            <div style={{ fontSize:11, color:C.textLight, letterSpacing:"1px", textTransform:"uppercase", marginBottom:8, fontWeight:600 }}>À propos</div>
            <p style={{ fontSize:14, color:C.text, lineHeight:1.7 }}>{presta.description||"Prestataire mariage en Alsace."}</p>
          </div>

          {/* Details grid */}
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))", gap:12, marginBottom:20 }}>
            <div style={{ background:C.primaryBg, borderRadius:12, padding:"12px 16px" }}>
              <div style={{ fontSize:11, color:C.textLight, marginBottom:4 }}>Tarifs</div>
              <div style={{ fontSize:15, fontWeight:600, color:C.primary }}>{presta.prix_min&&presta.prix_max?`${presta.prix_min}€ – ${presta.prix_max}€`:"Sur devis"}</div>
            </div>
            <div style={{ background:C.primaryBg, borderRadius:12, padding:"12px 16px" }}>
              <div style={{ fontSize:11, color:C.textLight, marginBottom:4 }}>Zone</div>
              <div style={{ fontSize:15, fontWeight:600, color:C.primary }}>{presta.rayon_intervention_km?`${presta.rayon_intervention_km} km`:"Alsace"}</div>
            </div>
            {presta.site_web && <div style={{ background:C.primaryBg, borderRadius:12, padding:"12px 16px", gridColumn:"1/-1" }}>
              <div style={{ fontSize:11, color:C.textLight, marginBottom:4 }}>Site web</div>
              <a href={presta.site_web} target="_blank" rel="noreferrer" style={{ fontSize:13, color:C.primary, fontWeight:500 }}>{presta.site_web}</a>
            </div>}
            {presta.instagram && <div style={{ background:C.primaryBg, borderRadius:12, padding:"12px 16px" }}>
              <div style={{ fontSize:11, color:C.textLight, marginBottom:4 }}>Instagram</div>
              <div style={{ fontSize:13, color:C.primary, fontWeight:500 }}>{presta.instagram}</div>
            </div>}
            {presta.nb_mariages_realises > 0 && <div style={{ background:C.primaryBg, borderRadius:12, padding:"12px 16px" }}>
              <div style={{ fontSize:11, color:C.textLight, marginBottom:4 }}>Mariages réalisés</div>
              <div style={{ fontSize:15, fontWeight:600, color:C.primary }}>{presta.nb_mariages_realises}</div>
            </div>}
          </div>

          {/* CTA */}
          {contacted ? (
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              <button disabled style={{ width:"100%", padding:"14px", background:C.greenBg, color:C.green, border:`1px solid ${C.green}`, borderRadius:14, fontSize:15, fontWeight:600, cursor:"default" }}>
                ✓ Demande envoyée
              </button>
              <button onClick={()=>{onCancel(presta.id);onClose();}}
                style={{ width:"100%", padding:"11px", background:"transparent", color:"#E53935", border:"1px solid #E53935", borderRadius:14, fontSize:13, fontWeight:600, cursor:"pointer", transition:"all 0.2s" }}>
                × Annuler ma demande
              </button>
            </div>
          ) : (
            <>
              {presta.telephone && <a href={`tel:${presta.telephone}`} style={{width:"100%",padding:"14px",background:C.greenBg,color:C.green,border:`1px solid ${C.green}`,borderRadius:14,fontSize:15,fontWeight:600,cursor:"pointer",textDecoration:"none",textAlign:"center",display:"block",marginBottom:10}}>📞 Appeler {presta.telephone}</a>}
              <button onClick={()=>onContact(presta.id)}
                style={{ width:"100%", padding:"14px", background:C.primary, color:"#fff", border:"none", borderRadius:14, fontSize:15, fontWeight:600, cursor:"pointer", transition:"all 0.3s" }}>
                💌 Contacter ce prestataire
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// ============================================================
// APP ROOT
// ============================================================
export default function App() {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [passwordRecovery, setPasswordRecovery] = useState(false);
  const [newPassword, setNewPassword] = useState('');

  useEffect(() => {
    const loadProfile = async (session) => {
      if (!session) { setUser(null); setAuthLoading(false); return; }
      const userId = session.user.id;
      const email = (session.user.email || "").toLowerCase();
      if (email === ADMIN_EMAIL) {
        setUser({ id: userId, nom: "Admin", role: "admin", email });
        setAuthLoading(false); return;
      }
      const { data: couple } = await supabase.from("couples").select("*").eq("user_id", userId).single();
      if (couple) {
        setUser({ id:couple.id, nom:`${couple.prenom1} & ${couple.prenom2}`, date:couple.date_mariage, role:"couple", ville:couple.ville });
        setAuthLoading(false); return;
      }
      const { data: pro } = await supabase.from("prestataires").select("*").eq("user_id", userId).single();
      if (pro) setUser({ id:pro.id, nom:pro.nom_entreprise, role:"pro", data:pro });
      setAuthLoading(false);
    };

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'PASSWORD_RECOVERY') { setPasswordRecovery(true); setAuthLoading(false); return; }
      loadProfile(session);
    });
    return () => subscription.unsubscribe();
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setUser(null);
  };

  const handleNewPassword = async () => {
    if (newPassword.length < 8) { alert('Le mot de passe doit contenir au moins 8 caractères.'); return; }
    const { error } = await supabase.auth.updateUser({ password: newPassword });
    if (error) { alert(error.message); return; }
    setPasswordRecovery(false);
    setNewPassword('');
    alert('Mot de passe mis à jour ! Vous pouvez vous connecter.');
  };

  const inp = { width:"100%", padding:"11px 14px", borderRadius:10, border:"1.5px solid #F0E8EC", fontFamily:"'DM Sans',sans-serif", fontSize:14, outline:"none", color:"#2C1A22", boxSizing:"border-box" };

  if (authLoading) return null;
  if (passwordRecovery) return (
    <div style={{ minHeight:"100vh", background:"#FDFAF9", fontFamily:"'DM Sans',sans-serif", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ background:"white", borderRadius:24, padding:"clamp(20px,5vw,36px)", maxWidth:400, width:"100%", boxShadow:"0 4px 32px rgba(44,26,34,0.1)" }}>
        <div style={{ textAlign:"center", marginBottom:20 }}><Logo height={96}/></div>
        <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:22, textAlign:"center", marginBottom:6, color:"#2C1A22" }}>Nouveau mot de passe</h3>
        <p style={{ fontSize:12, color:"#7A5A65", textAlign:"center", marginBottom:24 }}>Choisissez un mot de passe sécurisé (8 caractères min.).</p>
        <div style={{ marginBottom:18 }}>
          <div style={{ fontSize:12, fontWeight:600, color:"#2C1A22", marginBottom:5 }}>Nouveau mot de passe</div>
          <input type="password" value={newPassword} onChange={e=>setNewPassword(e.target.value)} placeholder="••••••••" style={inp} onKeyDown={e=>e.key==="Enter"&&handleNewPassword()}/>
        </div>
        <button onClick={handleNewPassword} style={{ width:"100%", padding:"14px", background:"#B5647A", color:"white", border:"none", borderRadius:12, fontSize:15, fontWeight:600, cursor:"pointer" }}>Confirmer →</button>
      </div>
    </div>
  );
  if (!user) return <Welcome onLogin={u=>setUser(u)}/>;
  if (user.role === "admin") return (
    <AdminDashboard
      user={user}
      onLogout={handleLogout}
      onImpersonate={impersonated => setUser({ ...impersonated, _adminBack: true })}
    />
  );
  if (user._adminBack) {
    const backToAdmin = () => setUser({ id: user._adminId || user.id, nom: "Admin", role: "admin", email: ADMIN_EMAIL });
    if (user.role === "pro") return (
      <>
        <div style={{ background:"#2C1A22", color:"white", padding:"10px 24px", fontSize:13, display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <span>Mode admin — espace de <strong>{user.nom}</strong></span>
          <button onClick={backToAdmin} style={{ background:"#B5647A", color:"white", border:"none", borderRadius:8, padding:"5px 14px", fontSize:12, fontWeight:600, cursor:"pointer" }}>← Retour admin</button>
        </div>
        <ProDashboard user={user} onLogout={handleLogout}/>
      </>
    );
    return (
      <>
        <div style={{ background:"#2C1A22", color:"white", padding:"10px 24px", fontSize:13, display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <span>Mode admin — espace de <strong>{user.nom}</strong></span>
          <button onClick={backToAdmin} style={{ background:"#B5647A", color:"white", border:"none", borderRadius:8, padding:"5px 14px", fontSize:12, fontWeight:600, cursor:"pointer" }}>← Retour admin</button>
        </div>
        <CoupleDashboard user={user} onLogout={handleLogout}/>
      </>
    );
  }
  if (user.role === "pro") return <ProDashboard user={user} onLogout={handleLogout}/>;
  return <CoupleDashboard user={user} onLogout={handleLogout}/>;
}

// ============================================================
// COUPLE DASHBOARD
// ============================================================
function CoupleDashboard({ user, onLogout }) {
  const [tab, setTab] = useState(0);
  const [dark, setDark] = useState(false);
  const [etapes, setEtapes] = useState(()=>{
    try { const s=localStorage.getItem(`wedyra_etapes_${user.id}`); return s?JSON.parse(s):ETAPES; } catch { return ETAPES; }
  });
  const [budgetItems, setBudgetItems] = useState(()=>{
    try { const s=localStorage.getItem(`wedyra_budget_${user.id}`); return s?JSON.parse(s):BUDGET_INIT; } catch { return BUDGET_INIT; }
  });
  const [editBudget, setEditBudget] = useState(null);
  const [showAddBudget, setShowAddBudget] = useState(false);
  const [editBudgetTotal, setEditBudgetTotal] = useState(false);
  const [budgetGlobal, setBudgetGlobal] = useState(20000);
  const [newPoste, setNewPoste] = useState({label:"",budget:"",depense:""});
  const [showAI, setShowAI] = useState(false);
  const [aiText, setAiText] = useState("");
  const [loadingAI, setLoadingAI] = useState(false);
  const [invites, setInvites] = useState([]);
  const [matchResults, setMatchResults] = useState([]);
  const [loadingMatch, setLoadingMatch] = useState(false);
  const [contactedIds, setContactedIds] = useState([]);
  const [selectedPresta, setSelectedPresta] = useState(null);
  const [chatUnread, setChatUnread] = useState(0);

  const C = dark ? DARK : LIGHT;
  const totalB = budgetItems.reduce((s,i)=>s+(Number(i.budget)||0),0);
  const totalD = budgetItems.reduce((s,i)=>s+(Number(i.depense)||0),0);
  const totalFait = etapes.filter(e=>e.fait).length;
  const pctCL = Math.round((totalFait/etapes.length)*100);
  const pctBG = totalB>0?Math.round((totalD/totalB)*100):0;
  const dateM = user.date?new Date(user.date):new Date("2026-07-15");
  const jours = Math.max(0,Math.ceil((dateM-new Date())/86400000));
  useEffect(()=>{ if(user.id) localStorage.setItem(`wedyra_etapes_${user.id}`,JSON.stringify(etapes)); },[etapes,user.id]);
  useEffect(()=>{ if(user.id) localStorage.setItem(`wedyra_budget_${user.id}`,JSON.stringify(budgetItems)); },[budgetItems,user.id]);

  const toggle = id=>setEtapes(e=>e.map(x=>x.id===id?{...x,fait:!x.fait}:x));
  const presC = invites.filter(i=>["present","present_deux","celebrer"].includes(i.response)).length;
  const absC = invites.filter(i=>i.response==="absent").length;

  const TABS = ["Vue d'ensemble","Checklist","Budget","✦ Matching","💬 Messages","🌸 Faire-parts","💌 Invités","⭐ Avis"];
  const card = { background:C.card, borderRadius:18, padding:"22px 24px", border:`1px solid ${C.cardBorder}`, marginBottom:16 };
  const inp = { padding:"10px 14px", borderRadius:10, border:`1px solid ${C.cardBorder}`, background:C.card, color:C.text, fontFamily:"'DM Sans',sans-serif", fontSize:13, outline:"none", width:"100%", boxSizing:"border-box" };
  const statColors = { "payé":{background:C.greenBg,color:C.green}, "acompte":{background:C.blueBg,color:C.blue}, "en discussion":{background:C.amberBg,color:C.amber}, "à réserver":{background:C.primaryBg,color:C.textMuted}, "confirmé":{background:C.greenBg,color:C.green} };

  useEffect(()=>{
    if(!user?.id)return;
    supabase.from("rsvp").select("*").eq("couple_id",user.id).order("created_at").then(({data})=>{
      if(data?.length) setInvites(data.map(r=>({id:r.faire_part_id,name:r.name,email:r.email,response:r.response,note:r.note,date:r.created_at})));
    }).catch(()=>{});
    // Load already contacted prestataires
    supabase.from("demandes_contact").select("prestataire_id").eq("couple_id",user.id).then(({data})=>{
      if(data) setContactedIds(data.map(d=>d.prestataire_id));
    }).catch(()=>{});
  },[user?.id]);

  const handleUpdateInvites = async(list)=>{
    setInvites(list);
    if(user.id&&list.length>0){
      const l=list[list.length-1];
      await supabase.from("rsvp").upsert({couple_id:user.id,faire_part_id:l.id?.toString()||Date.now().toString(),name:l.name,email:l.email||null,response:l.response,note:l.note||null},{onConflict:"faire_part_id"}).catch(()=>{});
    }
  };

  const getAI = async()=>{
    setLoadingAI(true);setShowAI(true);setAiText("");
    const etapesFaites = etapes.filter(e=>e.fait).map(e=>e.titre);
    const etapesRestantes = etapes.filter(e=>!e.fait).map(e=>`${e.titre} (${e.delai})`);
    const postesAlerte = budgetItems.filter(i=>i.budget>0&&i.depense>i.budget).map(i=>i.label);
    const postesVides = budgetItems.filter(i=>i.budget===0).map(i=>i.label);
    const nbPresents = invites.filter(i=>["present","present_deux","celebrer"].includes(i.response)).length;
    const prompt = `Tu es un wedding planner expert et bienveillant qui conseille les futurs mariés sur la plateforme Wedyra.

SITUATION DU COUPLE :
- Couple : ${user.nom}${user.ville ? ` (${user.ville})` : ""}
- Date du mariage : ${new Date(user.date||"2026-07-15").toLocaleDateString("fr-FR",{day:"numeric",month:"long",year:"numeric"})} — dans ${jours} jours
- Invités confirmés : ${nbPresents} présents sur ${invites.length} réponses

CHECKLIST (${pctCL}% complétée) :
- Étapes faites : ${etapesFaites.length > 0 ? etapesFaites.join(", ") : "aucune"}
- Étapes restantes : ${etapesRestantes.slice(0,5).join(" | ")}

BUDGET :
- Prévu : ${totalB.toLocaleString()}€ | Engagé : ${totalD.toLocaleString()}€ | Restant : ${(totalB-totalD).toLocaleString()}€
${postesAlerte.length>0 ? `- ⚠️ Dépassement sur : ${postesAlerte.join(", ")}` : ""}
${postesVides.length>0 ? `- Postes non budgétisés : ${postesVides.join(", ")}` : ""}

Ta mission : donne 2 à 3 conseils **concrets et prioritaires** pour cette semaine, adaptés exactement à leur situation. Sois chaleureux, précis, et actionnable. Utilise des listes courtes si utile. Maximum 150 mots.`;
    try {
      const res = await fetch("/api/ai", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ model:"claude-sonnet-4-20250514", max_tokens:500, messages:[{role:"user",content:prompt}] }),
      });
      const d = await res.json();
      if (!res.ok) throw new Error(d?.error || `HTTP ${res.status}`);
      if (d?.error?.type === "invalid_request_error" && d?.error?.message?.includes("credit")) {
        setAiText("⚠️ Crédits Anthropic épuisés. Rechargez votre compte sur console.anthropic.com → Plans & Billing.");
      } else {
        setAiText(d?.content?.[0]?.text || `⚠️ Réponse inattendue : ${JSON.stringify(d).substring(0, 200)}`);
      }
    } catch(err) { setAiText(`⚠️ Erreur IA : ${err?.message || JSON.stringify(err) || "service indisponible"}`); }
    setLoadingAI(false);
  };

  const doMatch = async()=>{
    setLoadingMatch(true);
    try {
      const {data, error} = await supabase.from("prestataires").select("*, abonnement_plan, prestataire_categories(categorie_id, categories(nom,slug,icone))").eq("is_active",true).order("note_moyenne",{ascending:false}).limit(20);
      if(error) {
        // Fallback : requête simplifiée sans les jointures
        const {data: data2, error: err2} = await supabase.from("prestataires").select("*").limit(20);
        if(err2 || !data2?.length) { setMatchResults(DEMO_MATCH); setLoadingMatch(false); return; }
        const scored2 = data2.map(p=>({...p, score:70, matchCats:[]})).sort((a,b)=>b.score-a.score);
        setMatchResults(scored2); setLoadingMatch(false); return;
      }
      if(data?.length){
        const scored = data.map(p=>{
          let score = (p.note_moyenne||0)*20;
          if(p.abonnement_plan==="elite") score += 25;
          else if(p.abonnement_plan==="premium") score += 15;
          else if(p.abonnement_plan==="essentiel") score += 8;
          if(p.ville && user.ville && p.ville.toLowerCase()===user.ville?.toLowerCase()) score += 15;
          if(p.nb_avis>20) score += 5;
          else if(p.nb_avis>10) score += 3;
          const cats = p.prestataire_categories?.map(pc=>pc.categories?.nom).filter(Boolean) || [];
          return {...p, score:Math.min(99,Math.round(score)), matchCats:cats};
        }).sort((a,b)=>b.score-a.score);
        setMatchResults(scored);
      } else setMatchResults(DEMO_MATCH);
    } catch(err) { console.error("doMatch error:", err); setMatchResults(DEMO_MATCH); }
    setLoadingMatch(false);
  };

  const contactPresta = async(prestaId)=>{
    if(contactedIds.includes(prestaId)) return;
    try {
      if(user.id) {
        await supabase.from("demandes_contact").upsert({couple_id:user.id,prestataire_id:prestaId,message:`${user.nom} souhaite vous contacter pour leur mariage.`,statut:"envoyee"},{onConflict:"couple_id,prestataire_id"});
      }
    } catch {}
    setContactedIds(prev=>[...prev,prestaId]);
  };

  const cancelContact = async(prestaId)=>{
    try {
      if(user.id) {
        await supabase.from("demandes_contact").delete().eq("couple_id",user.id).eq("prestataire_id",prestaId);
      }
    } catch {}
    setContactedIds(prev=>prev.filter(id=>id!==prestaId));
  };

  return (
    <div style={{ minHeight:"100vh", background:C.page, fontFamily:"'DM Sans',sans-serif", color:C.text, transition:"background 0.3s" }}>
      {/* Header */}
      <header style={{ background:C.header, borderBottom:`1px solid ${C.headerBorder}`, position:"sticky", top:0, zIndex:10 }}>
        <div style={{ maxWidth:1100, margin:"0 auto", height:"var(--header-height)", padding:"0 var(--header-padding-x)", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <div className="header-left">
            <button className="logo-link"><Logo height={96} dark={dark}/></button>
          </div>
          <div className="header-right">
            <div className="icon-btn" onClick={()=>setDark(!dark)} style={{gap:6}}>
              <span style={{fontSize:13}}>{dark?"🌙":"☀️"}</span>
              <div style={{ width:34, height:20, borderRadius:100, background:dark?C.primary:C.cardBorder, display:"flex", alignItems:"center", padding:"2px" }}><div style={{ width:16, height:16, borderRadius:"50%", background:"#fff", transform:dark?"translateX(14px)":"translateX(0)", transition:"transform 0.3s" }}/></div>
            </div>
            <div className="pill-btn">🌸 {user.nom}</div>
            <button className="text-btn logout-btn" onClick={onLogout} style={{color:C.textLight, whiteSpace:"nowrap", flexShrink:0}}>Déconnexion</button>
          </div>
        </div>
      </header>

      <div className="dash-container">
        {/* Hero */}
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:32, flexWrap:"wrap", gap:16 }}>
          <div><h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:"clamp(26px,4vw,38px)", fontWeight:400, color:C.text, lineHeight:1.2, marginBottom:6 }}>Votre mariage, <em style={{color:C.primary}}>organisé</em></h1><p style={{ fontSize:14, color:C.textLight }}>{dateM.toLocaleDateString("fr-FR",{day:"numeric",month:"long",year:"numeric"})}</p></div>
          <div style={{ background:C.primary, borderRadius:18, padding:"18px 28px", textAlign:"center" }}><div style={{ fontFamily:"'Playfair Display',serif", fontSize:38, color:"#fff", lineHeight:1 }}>{jours}</div><div style={{ fontSize:11, color:"rgba(255,255,255,0.75)", marginTop:4 }}>jours restants</div></div>
        </div>

        {/* Stats */}
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))", gap:14, marginBottom:28 }}>
          {[{l:"Checklist",v:`${pctCL}%`,s:`${totalFait}/${etapes.length}`,c:C.primary,p:pctCL},{l:"Budget",v:`${pctBG}%`,s:`${totalD.toLocaleString()}€/${totalB.toLocaleString()}€`,c:C.amber,p:pctBG},{l:"Matching",v:matchResults.length?"✓":"—",s:matchResults.length?`${matchResults.length} résultats`:"Lancer",c:C.green,p:matchResults.length?80:0},{l:"Invités",v:`${invites.length}`,s:`${presC} présents · ${absC} absents`,c:C.primaryLight,p:invites.length?Math.round(presC/invites.length*100):0}].map((s,i)=>(
            <div key={i} className="fade-in" style={{ background:C.card, borderRadius:16, padding:"18px 20px", border:`1px solid ${C.cardBorder}` }}>
              <div style={{ fontSize:11, color:C.textLight, letterSpacing:"1px", textTransform:"uppercase", marginBottom:8, fontWeight:600 }}>{s.l}</div>
              <div style={{ fontFamily:"'Playfair Display',serif", fontSize:28, color:C.text, marginBottom:4 }}>{s.v}</div>
              <div style={{ fontSize:12, color:C.textLight, marginBottom:10 }}>{s.s}</div>
              <Bar pct={s.p} color={s.c} bg={C.progressBg}/>
            </div>
          ))}
        </div>

        {/* Tabs */}
        <div className="tabs-scroll" style={{ display:"flex", gap:4, marginBottom:22, background:C.primaryBg, borderRadius:100, padding:4, width:"100%", overflowX:"auto", WebkitOverflowScrolling:"touch" }}>
          {TABS.map((t,i)=><button key={t} onClick={()=>{setTab(i);if(i===3&&!matchResults.length)doMatch();}} style={{ padding:"8px 16px", borderRadius:100, border:"none", cursor:"pointer", fontSize:13, fontWeight:500, background:tab===i?C.primary:"transparent", color:tab===i?"#fff":C.textMuted, transition:"all 0.2s", flexShrink:0, whiteSpace:"nowrap", position:"relative" }}>
            {t}
            {t.includes("Messages") && chatUnread > 0 && tab!==i && <span style={{ position:"absolute", top:2, right:2, minWidth:16, height:16, borderRadius:"50%", background:"#E53935", color:"#fff", fontSize:9, fontWeight:700, display:"flex", alignItems:"center", justifyContent:"center", padding:"0 3px" }}>{chatUnread > 9 ? "9+" : chatUnread}</span>}
          </button>)}
        </div>

        {/* TAB 0 */}
        {tab===0&&<div className="fade-in">
          <div style={{...card,background:C.primaryBg,border:`1px solid ${C.primaryBorder}`}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12,marginBottom:showAI?16:0}}>
              <div><div style={{fontSize:11,color:C.primary,letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:4,fontWeight:600}}>🌸 Assistant Wedyra</div><div style={{fontFamily:"'Playfair Display',serif",fontSize:18,color:C.text}}>Que faire cette semaine ?</div></div>
              <button onClick={getAI} style={{background:C.primary,color:"#fff",border:"none",borderRadius:10,padding:"10px 18px",fontSize:13,fontWeight:600,cursor:"pointer"}}>✦ Demander conseil</button>
            </div>
            {showAI&&<div style={{marginTop:16,padding:16,background:C.card,borderRadius:12,border:`1px solid ${C.primaryBorder}`}}>{loadingAI?<div><div className="shimmer" style={{marginBottom:8,width:"85%"}}/><div className="shimmer" style={{width:"60%"}}/></div>:<p style={{color:C.text,fontSize:14,lineHeight:1.7}}>{aiText}</p>}</div>}
          </div>
          <div style={card}>
            <div style={{fontSize:11,color:C.textLight,letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:18,fontWeight:600}}>Prochaines étapes</div>
            {etapes.filter(e=>!e.fait).slice(0,4).map(e=><div key={e.id} className="row-hover" style={{display:"flex",alignItems:"center",gap:12,padding:"11px 6px",borderBottom:`1px solid ${C.cardBorder}`,cursor:"pointer"}} onClick={()=>toggle(e.id)} onMouseEnter={el=>el.currentTarget.style.background=C.rowHover} onMouseLeave={el=>el.currentTarget.style.background="transparent"}>
              <div style={{width:20,height:20,borderRadius:"50%",border:`2px solid ${C.primaryBorder}`,flexShrink:0}}/>
              <div style={{flex:1}}><div style={{fontSize:14,color:C.text,fontWeight:500}}>{e.titre}</div><div style={{fontSize:12,color:C.textLight,marginTop:2}}>{e.delai}</div></div>
              <div style={{fontSize:11,color:CAT_COLORS[e.categorie]||C.textMuted,background:`${CAT_COLORS[e.categorie]||"#999"}18`,padding:"2px 8px",borderRadius:100,fontWeight:500}}>{e.categorie}</div>
            </div>)}
          </div>
        </div>}

        {/* TAB 1 — Checklist */}
        {tab===1&&<div className="fade-in" style={card}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
            <div><div style={{fontFamily:"'Playfair Display',serif",fontSize:22,color:C.text,marginBottom:4}}>Checklist</div><div style={{color:C.textLight,fontSize:13}}>{totalFait}/{etapes.length}</div></div>
            <div style={{width:52,height:52,borderRadius:"50%",background:C.primary,display:"flex",alignItems:"center",justifyContent:"center"}}><span style={{color:"#fff",fontSize:14}}>{pctCL}%</span></div>
          </div>
          <Bar pct={pctCL} color={C.primary} bg={C.progressBg}/>
          <div style={{marginTop:18}}>{etapes.map(e=><div key={e.id} className="row-hover" style={{display:"flex",alignItems:"center",gap:12,padding:"11px 6px",borderBottom:`1px solid ${C.cardBorder}`,cursor:"pointer"}} onClick={()=>toggle(e.id)} onMouseEnter={el=>el.currentTarget.style.background=C.rowHover} onMouseLeave={el=>el.currentTarget.style.background="transparent"}>
            <div style={{width:20,height:20,borderRadius:"50%",border:`2px solid ${e.fait?C.primary:C.primaryBorder}`,background:e.fait?C.primary:"transparent",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center"}}>{e.fait&&<span style={{color:"#fff",fontSize:10}}>✓</span>}</div>
            <div style={{flex:1}}><div style={{fontSize:14,color:e.fait?C.textLight:C.text,fontWeight:500,textDecoration:e.fait?"line-through":"none"}}>{e.titre}</div><div style={{fontSize:12,color:C.textLight,marginTop:2}}>{e.delai}</div></div>
            <div style={{fontSize:11,color:CAT_COLORS[e.categorie]||C.textMuted,background:`${CAT_COLORS[e.categorie]||"#999"}18`,padding:"2px 8px",borderRadius:100,fontWeight:500}}>{e.categorie}</div>
          </div>)}</div>
        </div>}

        {/* TAB 2 — Budget */}
        {tab===2&&<div className="fade-in">
  {/* Stats budget */}
  <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(120px,1fr))",gap:14,marginBottom:16}}>
    <div style={{background:C.card,borderRadius:16,padding:"16px 18px",border:`1px solid ${C.cardBorder}`,textAlign:"center",cursor:"pointer"}} onClick={()=>setEditBudgetTotal(true)}>
      <div style={{fontSize:11,color:C.textLight,letterSpacing:"1px",textTransform:"uppercase",marginBottom:8,fontWeight:600}}>Budget total</div>
      {editBudgetTotal
        ? <input autoFocus type="number" defaultValue={budgetGlobal}
            onBlur={e=>{setBudgetGlobal(+e.target.value||0);setEditBudgetTotal(false);}}
            onKeyDown={e=>{if(e.key==="Enter")e.target.blur();}}
            style={{fontFamily:"'Playfair Display',serif",fontSize:22,color:C.text,width:"100%",textAlign:"center",border:`1.5px solid ${C.primary}`,borderRadius:8,padding:"4px",background:C.card,outline:"none"}}/>
        : <div style={{fontFamily:"'Playfair Display',serif",fontSize:22,color:C.text,border:`1px dashed ${C.cardBorder}`,borderRadius:8,padding:"4px"}}>{budgetGlobal.toLocaleString()}€</div>
      }
    </div>
    <div style={{background:C.card,borderRadius:16,padding:"16px 18px",border:`1px solid ${C.cardBorder}`,textAlign:"center"}}>
      <div style={{fontSize:11,color:C.textLight,letterSpacing:"1px",textTransform:"uppercase",marginBottom:8,fontWeight:600}}>Engagé</div>
      <div style={{fontFamily:"'Playfair Display',serif",fontSize:22,color:C.amber}}>{totalD.toLocaleString()}€</div>
    </div>
    <div style={{background:C.card,borderRadius:16,padding:"16px 18px",border:`1px solid ${C.cardBorder}`,textAlign:"center"}}>
      <div style={{fontSize:11,color:C.textLight,letterSpacing:"1px",textTransform:"uppercase",marginBottom:8,fontWeight:600}}>Restant</div>
      <div style={{fontFamily:"'Playfair Display',serif",fontSize:22,color:(budgetGlobal-totalD)>0?C.green:C.primary}}>{(budgetGlobal-totalD).toLocaleString()}€</div>
    </div>
  </div>
  <div style={{background:C.card,borderRadius:16,padding:"16px 18px",border:`1px solid ${C.cardBorder}`,marginBottom:16}}>
    <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
      <span style={{fontSize:12,color:C.textLight,fontWeight:600}}>Progression globale</span>
      <span style={{fontSize:12,fontWeight:600,color:budgetGlobal>0&&(totalD/budgetGlobal)>0.9?C.primary:budgetGlobal>0&&(totalD/budgetGlobal)>0.7?C.amber:C.green}}>{budgetGlobal>0?Math.round((totalD/budgetGlobal)*100):0}%</span>
    </div>
    <div style={{height:10,borderRadius:5,background:C.progressBg,overflow:"hidden"}}>
      <div style={{height:"100%",borderRadius:5,width:`${budgetGlobal>0?Math.min(100,(totalD/budgetGlobal)*100):0}%`,background:budgetGlobal>0&&(totalD/budgetGlobal)>0.9?C.primary:budgetGlobal>0&&(totalD/budgetGlobal)>0.7?C.amber:C.green,transition:"width 0.5s, background 0.5s"}}/>
    </div>
  </div>
  <div style={card}>
    {budgetItems.map(item=>{
      const pct=item.budget>0?Math.min(100,Math.round((item.depense/item.budget)*100)):0;
      const barColor=pct>=100?C.primary:pct>=70?C.amber:C.green;
      return <div key={item.id} style={{padding:"14px 0",borderBottom:`1px solid ${C.cardBorder}`}}>
        <div style={{display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
          <div style={{width:8,height:8,borderRadius:"50%",background:CAT_COLORS[item.categorie]||C.primary,flexShrink:0}}/>
          <div style={{flex:1,minWidth:120}}>
            <div style={{fontSize:14,color:C.text,fontWeight:500}}>{item.label}</div>
            <div style={{fontSize:12,color:C.textLight}}>{item.categorie}</div>
          </div>
          <div style={{textAlign:"right"}}><div style={{fontSize:10,color:C.textLight,marginBottom:3}}>Dépensé</div>
            {editBudget?.id===item.id&&editBudget?.f==="d"?<input autoFocus type="number" defaultValue={item.depense} onBlur={e=>{setBudgetItems(b=>b.map(x=>x.id===item.id?{...x,depense:+e.target.value||0}:x));setEditBudget(null);}} onKeyDown={e=>e.key==="Enter"&&e.target.blur()} style={{width:80,padding:"3px 8px",borderRadius:8,border:`1.5px solid ${C.primary}`,background:C.card,color:C.text,fontSize:13,textAlign:"right"}}/>
            :<div onClick={()=>setEditBudget({id:item.id,f:"d"})} style={{fontSize:14,fontWeight:600,color:barColor,cursor:"pointer",padding:"2px 6px",borderRadius:6,border:`1px dashed ${C.cardBorder}`}}>{(item.depense||0).toLocaleString()}€</div>}
          </div>
          <span style={{color:C.textLight}}>/</span>
          <div style={{textAlign:"right"}}><div style={{fontSize:10,color:C.textLight,marginBottom:3}}>Prévu</div>
            {editBudget?.id===item.id&&editBudget?.f==="b"?<input autoFocus type="number" defaultValue={item.budget} onBlur={e=>{setBudgetItems(b=>b.map(x=>x.id===item.id?{...x,budget:+e.target.value||0}:x));setEditBudget(null);}} onKeyDown={e=>e.key==="Enter"&&e.target.blur()} style={{width:80,padding:"3px 8px",borderRadius:8,border:`1.5px solid ${C.primary}`,background:C.card,color:C.text,fontSize:13,textAlign:"right"}}/>
            :<div onClick={()=>setEditBudget({id:item.id,f:"b"})} style={{fontSize:14,fontWeight:600,color:C.text,cursor:"pointer",padding:"2px 6px",borderRadius:6,border:`1px dashed ${C.cardBorder}`}}>{(item.budget||0).toLocaleString()}€</div>}
          </div>
          <select value={item.statut} onChange={e=>setBudgetItems(b=>b.map(x=>x.id===item.id?{...x,statut:e.target.value}:x))} style={{padding:"3px 8px",borderRadius:100,fontSize:11,fontWeight:500,border:"none",cursor:"pointer",...(statColors[item.statut]||{background:C.primaryBg,color:C.textMuted})}}>{["à réserver","en discussion","acompte","confirmé","payé"].map(s=><option key={s} value={s}>{s}</option>)}</select>
          <button onClick={()=>setBudgetItems(b=>b.filter(x=>x.id!==item.id))} style={{background:"none",border:"none",color:C.textLight,fontSize:18,cursor:"pointer"}}>×</button>
        </div>
        <div style={{marginTop:8,marginLeft:22}}>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
            <span style={{fontSize:10,color:C.textLight}}>{pct}%</span>
            {pct>=100&&<span style={{fontSize:10,color:C.primary,fontWeight:600}}>Budget atteint</span>}
            {pct>=70&&pct<100&&<span style={{fontSize:10,color:C.amber,fontWeight:600}}>Attention</span>}
          </div>
          <div style={{height:6,borderRadius:3,background:C.progressBg,overflow:"hidden"}}>
            <div style={{height:"100%",borderRadius:3,width:`${pct}%`,background:barColor,transition:"width 0.5s, background 0.5s"}}/>
          </div>
        </div>
      </div>;
    })}
    {showAddBudget?<div style={{padding:"16px 0",display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
      <input placeholder="Nom du poste" value={newPoste.label} onChange={e=>setNewPoste(p=>({...p,label:e.target.value}))} style={{...inp,gridColumn:"1/-1"}}/>
      <input type="number" placeholder="Budget (€)" value={newPoste.budget} onChange={e=>setNewPoste(p=>({...p,budget:e.target.value}))} style={inp}/>
      <input type="number" placeholder="Dépensé (€)" value={newPoste.depense} onChange={e=>setNewPoste(p=>({...p,depense:e.target.value}))} style={inp}/>
      <div style={{display:"flex",gap:8,gridColumn:"1/-1"}}>
        <button onClick={()=>{if(!newPoste.label)return;setBudgetItems(b=>[...b,{id:Date.now(),categorie:"Autre",label:newPoste.label,budget:+newPoste.budget||0,depense:+newPoste.depense||0,statut:"à réserver"}]);setNewPoste({label:"",budget:"",depense:""});setShowAddBudget(false);}} style={{flex:1,padding:"10px",background:C.primary,color:"#fff",border:"none",borderRadius:10,fontSize:13,fontWeight:600,cursor:"pointer"}}>Ajouter</button>
        <button onClick={()=>setShowAddBudget(false)} style={{padding:"10px 16px",background:"transparent",border:`1px solid ${C.cardBorder}`,borderRadius:10,color:C.textMuted,fontSize:13,cursor:"pointer"}}>Annuler</button>
      </div>
    </div>:<button onClick={()=>setShowAddBudget(true)} style={{marginTop:16,background:"none",border:"none",color:C.primary,fontSize:13,cursor:"pointer",fontWeight:600}}>+ Ajouter un poste</button>}
  </div>
</div>}

        {/* TAB 3 — Matching (FIXED) */}
        {tab===3&&<div className="fade-in">
          <div style={{...card,background:C.primaryBg,border:`1px solid ${C.primaryBorder}`,textAlign:"center",padding:"28px 24px"}}>
            <div style={{fontSize:32,marginBottom:8}}>✦</div>
            <div style={{fontFamily:"'Playfair Display',serif",fontSize:22,color:C.text,marginBottom:6}}>Matching IA Wedyra</div>
            <p style={{fontSize:14,color:C.textLight,maxWidth:460,margin:"0 auto 18px"}}>Nous trouvons les meilleurs prestataires pour votre projet.</p>
            <button onClick={doMatch} disabled={loadingMatch} style={{padding:"12px 28px",background:C.primary,color:"#fff",border:"none",borderRadius:12,fontSize:14,fontWeight:600,cursor:"pointer",opacity:loadingMatch?0.6:1}}>{loadingMatch?"Recherche...":"✦ Trouver mes prestataires"}</button>
          </div>

          {matchResults.length>0&&<div style={{display:"grid",gap:14,marginTop:4}}>
            {matchResults.map(p=>{
              const isContacted = contactedIds.includes(p.id);
              const isPaid = ["essentiel","premium","elite"].includes(p.abonnement_plan);
              return <div key={p.id} style={{
                ...card, marginBottom:0,
                border: p.abonnement_plan==="elite" ? `2px solid ${C.amber}`
                      : p.abonnement_plan==="premium" ? `2px solid ${C.primary}`
                      : `1px solid ${C.cardBorder}`,
                background: p.abonnement_plan==="elite" ? C.amberBg : C.card,
              }}><div className="match-row">
                <div style={{position:"relative"}}>
                  <div style={{width:56,height:56,borderRadius:16,background:C.primaryBg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:24}}>{p.matchCats?.[0]==="Photographe"?"📸":p.matchCats?.[0]==="DJ / Musique"?"🎵":p.matchCats?.[0]==="Fleuriste"?"💐":p.matchCats?.[0]==="Traiteur"?"🍽️":"🌸"}</div>
                  <div style={{position:"absolute",bottom:-4,right:-4,width:26,height:26,borderRadius:"50%",background:p.score>=90?C.green:p.score>=80?C.amber:C.primaryLight,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700,color:"#fff",border:`2px solid ${C.card}`}}>{p.score}</div>
                </div>
                <div style={{flex:1}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:4}}>
                    <div>
                      <div style={{display:"flex",alignItems:"center",gap:8}}>
                        <span style={{fontFamily:"'Playfair Display',serif",fontSize:18,color:C.text}}>{p.nom_entreprise}</span>
                        {p.abonnement_plan==="elite"&&<span style={{fontSize:10,background:C.amberBg,color:C.amber,padding:"2px 8px",borderRadius:100,fontWeight:600}}>👑 Elite</span>}
                        {p.abonnement_plan==="premium"&&<span style={{fontSize:10,background:C.amberBg,color:C.amber,padding:"2px 8px",borderRadius:100,fontWeight:600}}>⭐ Premium</span>}
                        {p.abonnement_plan==="essentiel"&&<span style={{fontSize:10,background:C.greenBg,color:C.green,padding:"2px 8px",borderRadius:100,fontWeight:600}}>✓ Vérifié</span>}
                      </div>
                      <div style={{fontSize:12,color:C.textLight,marginTop:2}}>📍 {p.ville||"Alsace"} · {p.matchCats?.join(", ")}</div>
                    </div>
                    <div style={{textAlign:"right"}}>
                      <div style={{fontSize:13,fontWeight:600,color:C.text}}>⭐ {p.note_moyenne||"N/A"} <span style={{fontWeight:400,color:C.textLight}}>({p.nb_avis||0})</span></div>
                      <div style={{fontSize:12,color:C.primary,fontWeight:600,marginTop:2}}>{p.prix_min&&p.prix_max?`${p.prix_min}€ – ${p.prix_max}€`:"Sur devis"}</div>
                    </div>
                  </div>
                  <p style={{fontSize:13,color:C.textMuted,lineHeight:1.5,marginTop:6,marginBottom:12}}>{p.description}</p>
                  <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                    {isContacted ? (
                      <>
                        <button style={{padding:"8px 18px",background:C.greenBg,color:C.green,border:`1px solid ${C.green}`,borderRadius:10,fontSize:12,fontWeight:600,cursor:"default"}}>✓ Demande envoyée</button>
                        <button onClick={()=>cancelContact(p.id)}
                          style={{padding:"8px 18px",background:"transparent",border:`1px solid ${C.cardBorder}`,borderRadius:10,fontSize:12,color:C.textMuted,cursor:"pointer",fontWeight:500,transition:"all 0.2s"}}
                          onMouseEnter={e=>{e.currentTarget.style.borderColor="#E53935";e.currentTarget.style.color="#E53935";}}
                          onMouseLeave={e=>{e.currentTarget.style.borderColor=C.cardBorder;e.currentTarget.style.color=C.textMuted;}}>
                          × Annuler ma demande
                        </button>
                      </>
                    ) : (
                      <button onClick={()=>contactPresta(p.id)}
                        style={{padding:"8px 18px",background:C.primary,color:"#fff",border:"none",borderRadius:10,fontSize:12,fontWeight:600,cursor:"pointer",transition:"all 0.3s"}}>
                        💌 Contacter →
                      </button>
                    )}
                    {p.telephone && <a href={`tel:${p.telephone}`} style={{padding:"8px 18px",background:C.greenBg,color:C.green,border:`1px solid ${C.green}`,borderRadius:10,fontSize:12,fontWeight:600,cursor:"pointer",textDecoration:"none",display:"flex",alignItems:"center",gap:4}}>📞 Appeler</a>}
                    <button onClick={()=>{
                        setSelectedPresta(p);
                        if(user.id && p.id){
                          supabase.from("profile_views").insert({prestataire_id:p.id,viewer_id:user.id,viewer_type:"couple",source:"matching"}).then(()=>{});
                        }
                      }}
                      style={{padding:"8px 18px",background:"transparent",border:`1px solid ${C.cardBorder}`,borderRadius:10,fontSize:12,color:C.text,cursor:"pointer",fontWeight:500,transition:"all 0.2s"}}
                      onMouseEnter={e=>e.currentTarget.style.borderColor=C.primary}
                      onMouseLeave={e=>e.currentTarget.style.borderColor=C.cardBorder}>
                      Voir le profil →
                    </button>
                  </div>
                </div>
              </div></div>;
            })}
          </div>}

          {/* Profil Modal */}
          {selectedPresta && <ProfilModal presta={selectedPresta} C={C} onClose={()=>setSelectedPresta(null)} onContact={(id)=>{contactPresta(id);setSelectedPresta(null);}} onCancel={cancelContact} contacted={contactedIds.includes(selectedPresta.id)}/>}
        </div>}

        {/* TAB 4 */}
        {tab===4&&<div className="fade-in"><Chat user={user} C={C} onUnreadChange={setChatUnread}/></div>}

        {tab===5&&<div className="fade-in"><FairePart user={user} C={C} onUpdateInvites={handleUpdateInvites}/></div>}

        {tab===6&&<div className="fade-in">
          {invites.length===0?<div style={{...card,textAlign:"center",padding:"60px 40px"}}><div style={{fontSize:40,marginBottom:16}}>💌</div><div style={{fontFamily:"'Playfair Display',serif",fontSize:22,color:C.text,marginBottom:10}}>Aucune réponse</div><p style={{fontSize:14,color:C.textLight,marginBottom:24}}>Envoyez vos faire-parts depuis l'onglet <strong>🌸 Faire-parts</strong>.</p><button onClick={()=>setTab(5)} style={{padding:"12px 28px",background:C.primary,color:"#fff",border:"none",borderRadius:12,fontSize:14,fontWeight:600,cursor:"pointer"}}>Faire-parts →</button></div>
          :<>
            {/* Compteurs */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(90px,1fr))",gap:14,marginBottom:20}}>
              {[
                {l:"Présents",v:presC,c:C.green,bg:C.greenBg,e:"✅"},
                {l:"Absents",v:absC,c:"#9B6B7A",bg:C.primaryBg,e:"💔"},
                {l:"En attente",v:invites.filter(i=>i.response==="plus_tard").length,c:C.textMuted,bg:C.primaryBg,e:"⏳"},
                {l:"Total couverts",v:invites.reduce((s,i)=>(i.nbGuests||1)+(i.nbChildren||0)+s,0),c:C.amber,bg:C.amberBg,e:"🍽️"},
              ].map((s,i)=><div key={i} style={{background:s.bg,borderRadius:14,padding:"14px",textAlign:"center",border:`1px solid ${C.cardBorder}`}}><div style={{fontSize:20,marginBottom:4}}>{s.e}</div><div style={{fontFamily:"'Playfair Display',serif",fontSize:24,color:s.c}}>{s.v}</div><div style={{fontSize:11,color:C.textLight}}>{s.l}</div></div>)}
            </div>
 
            {/* Résumé restrictions alimentaires */}
            {invites.some(i=>i.dietary?.length>0&&!i.dietary.includes("aucune"))&&<div style={{...card,background:C.amberBg,border:`1px solid ${C.amber}30`}}>
              <div style={{fontSize:11,color:C.amber,letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:12,fontWeight:600}}>🍽️ Résumé restrictions alimentaires</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                {(() => {
                  const counts = {};
                  invites.forEach(inv => {
                    (inv.dietary||[]).forEach(d => {
                      if(d!=="aucune") counts[d] = (counts[d]||0) + 1;
                    });
                  });
                  return Object.entries(counts).map(([key,count]) => {
                    const opt = [{key:"vegetarien",emoji:"🥬",label:"Végétarien"},{key:"vegan",emoji:"🌱",label:"Végan"},{key:"sans_gluten",emoji:"🌾",label:"Sans gluten"},{key:"sans_lactose",emoji:"🥛",label:"Sans lactose"},{key:"halal",emoji:"🍖",label:"Halal"},{key:"casher",emoji:"✡️",label:"Casher"},{key:"sans_porc",emoji:"🐷",label:"Sans porc"},{key:"fruits_mer",emoji:"🦐",label:"Fruits de mer"},{key:"noix",emoji:"🥜",label:"Noix"},{key:"autre",emoji:"⚠️",label:"Autre"}].find(o=>o.key===key);
                    return <span key={key} style={{padding:"5px 12px",background:C.card,borderRadius:100,fontSize:12,fontWeight:500,color:C.text,border:`1px solid ${C.cardBorder}`}}>{opt?.emoji} {opt?.label||key} × {count}</span>;
                  });
                })()}
              </div>
              <p style={{fontSize:11,color:C.textMuted,marginTop:10,fontStyle:"italic"}}>💡 Transmettez ces infos à votre traiteur pour anticiper les menus.</p>
            </div>}
 
            {/* Résumé chansons */}
            {invites.some(i=>i.song)&&<div style={{...card,background:C.blueBg,border:`1px solid ${C.blue}30`}}>
              <div style={{fontSize:11,color:C.blue,letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:10,fontWeight:600}}>🎵 Playlist demandée par vos invités</div>
              <div style={{display:"grid",gap:6}}>
                {invites.filter(i=>i.song).map((i,idx)=><div key={idx} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 10px",background:C.card,borderRadius:8,border:`1px solid ${C.cardBorder}`}}>
                  <span style={{fontSize:14}}>🎵</span>
                  <span style={{flex:1,fontSize:13,color:C.text,fontWeight:500}}>{i.song}</span>
                  <span style={{fontSize:11,color:C.textLight}}>— {i.name}</span>
                </div>)}
              </div>
              <p style={{fontSize:11,color:C.textMuted,marginTop:10,fontStyle:"italic"}}>💡 Partagez cette liste avec votre DJ.</p>
            </div>}
 
            {/* Résumé transport */}
            {invites.some(i=>i.transport)&&<div style={{...card}}>
              <div style={{fontSize:11,color:C.textLight,letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:10,fontWeight:600}}>🚗 Besoins transport & hébergement</div>
              <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
                {["navette","covoiturage","hebergement"].map(t=>{
                  const count=invites.filter(i=>i.transport===t).length;
                  if(!count) return null;
                  const labels={navette:"🚌 Navette",covoiturage:"🚗 Covoiturage",hebergement:"🏨 Hébergement"};
                  return <span key={t} style={{padding:"6px 14px",background:C.primaryBg,borderRadius:10,fontSize:13,fontWeight:500,color:C.primary}}>{labels[t]} : {count}</span>;
                })}
              </div>
            </div>}
 
            {/* Liste des réponses */}
            <div style={card}>
              <div style={{fontSize:11,color:C.textLight,letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:18,fontWeight:600}}>Réponses ({invites.length})</div>
              {invites.map((inv,i)=>{
                const opt=RSVP_OPTIONS.find(o=>o.key===inv.response);
                const isPres=["present","present_deux","celebrer"].includes(inv.response);
                return <div key={i} style={{padding:"14px 0",borderBottom:`1px solid ${C.cardBorder}`}}>
                  <div style={{display:"flex",alignItems:"center",gap:14}}>
                    <div style={{width:40,height:40,borderRadius:"50%",background:opt?.bg||C.primaryBg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>{opt?.emoji}</div>
                    <div style={{flex:1}}>
                      <div style={{display:"flex",alignItems:"center",gap:8}}>
                        <span style={{fontSize:14,fontWeight:600,color:C.text}}>{inv.name}</span>
                        {isPres&&(inv.nbGuests>1||inv.nbChildren>0)&&<span style={{fontSize:11,color:C.textMuted,background:C.primaryBg,padding:"2px 8px",borderRadius:100}}>👥 {inv.nbGuests||1}{inv.nbChildren>0?` + ${inv.nbChildren} enf.`:""}</span>}
                      </div>
                      {inv.email&&<div style={{fontSize:12,color:C.textLight}}>{inv.email}</div>}
                      {inv.note&&<div style={{fontSize:12,color:C.textMuted,fontStyle:"italic",marginTop:3}}>"{inv.note}"</div>}
                    </div>
                    <div style={{textAlign:"right"}}>
                      <span style={{fontSize:11,color:opt?.color,fontWeight:600,background:opt?.bg,padding:"3px 10px",borderRadius:100}}>{opt?.label?.split(" ").slice(0,3).join(" ")}</span>
                    </div>
                  </div>
                  {/* Détails supplémentaires */}
                  {isPres&&<div style={{marginLeft:54,marginTop:8,display:"flex",flexWrap:"wrap",gap:6}}>
                    {inv.dietary?.filter(d=>d!=="aucune").map(d=>{
                      const dOpt=[{key:"vegetarien",emoji:"🥬"},{key:"vegan",emoji:"🌱"},{key:"sans_gluten",emoji:"🌾"},{key:"sans_lactose",emoji:"🥛"},{key:"halal",emoji:"🍖"},{key:"casher",emoji:"✡️"},{key:"sans_porc",emoji:"🐷"},{key:"fruits_mer",emoji:"🦐"},{key:"noix",emoji:"🥜"},{key:"autre",emoji:"⚠️"}].find(o=>o.key===d);
                      return <span key={d} style={{fontSize:10,padding:"2px 8px",borderRadius:100,background:C.amberBg,color:C.amber,fontWeight:500}}>{dOpt?.emoji} {d}</span>;
                    })}
                    {inv.dietaryOther&&<span style={{fontSize:10,padding:"2px 8px",borderRadius:100,background:C.amberBg,color:C.amber}}>⚠️ {inv.dietaryOther}</span>}
                    {inv.song&&<span style={{fontSize:10,padding:"2px 8px",borderRadius:100,background:C.blueBg,color:C.blue}}>🎵 {inv.song}</span>}
                    {inv.transport&&<span style={{fontSize:10,padding:"2px 8px",borderRadius:100,background:C.primaryBg,color:C.primary}}>{{navette:"🚌",covoiturage:"🚗",hebergement:"🏨"}[inv.transport]} {inv.transport}</span>}
                  </div>}
                </div>;
              })}
            </div>
          </>}
        </div>}

        {tab===7&&<div className="fade-in"><CoupleAvis user={user} C={C}/></div>}
      </div>
    </div>
  );
}

// ============================================================
// PRO DASHBOARD
// ============================================================
function ProDashboard({ user, onLogout }) {
  const [dark, setDark] = useState(false);
  const [tab, setTab] = useState(0);
  const [demandes, setDemandes] = useState([]);
  const [proData] = useState(user.data||{});
  const [chatUnread, setChatUnread] = useState(0);
  const [trialInfo, setTrialInfo] = useState(null);
  const [showPricing, setShowPricing] = useState(false);
  const [trialExpired, setTrialExpired] = useState(false);
  const [stats, setStats] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [proForm, setProForm] = useState({
    nom_entreprise: proData.nom_entreprise || user.nom || "",
    email: proData.email || "",
    ville: proData.ville || "",
    telephone: proData.telephone || "",
    description: proData.description || "",
    site_web: proData.site_web || "",
    instagram: proData.instagram || "",
    prix_min: proData.prix_min || "",
    prix_max: proData.prix_max || "",
    rayon_intervention_km: proData.rayon_intervention_km || "",
  });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const C = dark ? DARK : LIGHT;
  const card = { background:C.card, borderRadius:18, padding:"22px 24px", border:`1px solid ${C.cardBorder}`, marginBottom:16 };

  useEffect(()=>{
    if(!user.id)return;
    supabase.from("demandes_contact").select("*, couples(prenom1,prenom2,email,date_mariage,ville)").eq("prestataire_id",user.id).order("created_at",{ascending:false}).then(({data})=>{ if(data) setDemandes(data); }).catch(()=>{});
  },[user.id]);

  useEffect(() => {
    if (!user.id) return;
    supabase.from("prestataires").select("trial_start, trial_end, abonnement_plan, abonnement_actif")
      .eq("id", user.id).single().then(({ data }) => {
        if (data) {
          const now = new Date();
          const start = new Date(data.trial_start);
          const end = new Date(data.trial_end);
          const totalDays = Math.ceil((end - start) / 86400000);
          const daysUsed = Math.ceil((now - start) / 86400000);
          const daysLeft = Math.max(0, Math.ceil((end - now) / 86400000));
          const monthsUsed = Math.floor(daysUsed / 30);
          const expired = now > end && data.abonnement_plan === "trial";
          const isPaid = ["essentiel", "premium", "elite"].includes(data.abonnement_plan);
          setTrialInfo({ ...data, daysLeft, daysUsed, monthsUsed, totalDays, expired, isPaid });
          if (expired && !isPaid) setTrialExpired(true);
        }
      });
  }, [user.id]);

  useEffect(()=>{
    if(!user.id) return;
    Promise.all([
      supabase.from("profile_views").select("id, created_at", {count:"exact"}).eq("prestataire_id", user.id),
      supabase.from("profile_views").select("id", {count:"exact"}).eq("prestataire_id", user.id).gte("created_at", new Date(Date.now()-7*86400000).toISOString()),
    ]).then(([all, week])=>{
      const total = all.count || 0;
      const last7 = week.count || 0;
      const accepted = demandes.filter(d=>d.statut==="acceptee").length;
      const contactRate = demandes.length > 0 ? Math.round((accepted / demandes.length) * 100) : 0;
      setStats({ totalViews: total, weekViews: last7, contactRate });
    }).catch(()=>{});
  },[user.id, demandes]);

  const saveProfile = async () => {
    setSaving(true);
    try {
      const { error } = await supabase.from("prestataires").update({
        nom_entreprise: proForm.nom_entreprise,
        ville: proForm.ville,
        telephone: proForm.telephone,
        description: proForm.description,
        site_web: proForm.site_web,
        instagram: proForm.instagram,
        prix_min: proForm.prix_min ? Number(proForm.prix_min) : null,
        prix_max: proForm.prix_max ? Number(proForm.prix_max) : null,
        rayon_intervention_km: proForm.rayon_intervention_km ? Number(proForm.rayon_intervention_km) : null,
      }).eq("id", user.id);
      if (error) { alert(error.message); }
      else { setSaved(true); setEditMode(false); setTimeout(() => setSaved(false), 3000); }
    } catch { alert("Erreur lors de la sauvegarde."); }
    setSaving(false);
  };

  const TABS = ["Vue d'ensemble","Demandes","💬 Messages","⭐ Avis","Mon profil"];

  if (trialExpired) return (
    <div style={{ minHeight:"100vh", background:C.page, fontFamily:"'DM Sans',sans-serif", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ maxWidth:620, width:"100%", textAlign:"center" }}>
        <div style={{ fontSize:48, marginBottom:16 }}>⏰</div>
        <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:32, fontWeight:400, color:C.text, marginBottom:12 }}>Votre période d'essai est terminée</h1>
        <p style={{ fontSize:15, color:C.textLight, marginBottom:32, lineHeight:1.7 }}>Choisissez un abonnement pour continuer à recevoir des demandes de couples.</p>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))", gap:16, marginBottom:28 }}>
          {[
            {plan:"Essentiel",price:"29€/mois",features:["Profil visible","Demandes illimitées","Messagerie"]},
            {plan:"Premium",price:"49€/mois",features:["Tout Essentiel","Mise en avant","Statistiques","Support prioritaire"],rec:true},
            {plan:"Élite",price:"79€/mois",features:["Tout Premium","Badge Élite","Nouvelles fonctions en avant-première"]},
          ].map((p,i)=>(
            <div key={i} style={{ background:C.card, border:`2px solid ${p.rec?C.primary:C.cardBorder}`, borderRadius:18, padding:"24px 20px", position:"relative" }}>
              {p.rec && <div style={{ position:"absolute", top:-10, left:"50%", transform:"translateX(-50%)", background:C.primary, color:"#fff", fontSize:10, padding:"3px 12px", borderRadius:100, fontWeight:600, whiteSpace:"nowrap" }}>Recommandé</div>}
              <div style={{ fontSize:17, fontWeight:600, color:C.text, marginBottom:8 }}>{p.plan}</div>
              <div style={{ fontFamily:"'Playfair Display',serif", fontSize:26, color:C.primary, marginBottom:12 }}>{p.price}</div>
              <ul style={{ listStyle:"none", padding:0, textAlign:"left" }}>
                {p.features.map((f,j)=><li key={j} style={{ fontSize:13, color:C.textLight, marginBottom:6 }}>✓ {f}</li>)}
              </ul>
              <a href="mailto:contact@wedyra.fr?subject=Abonnement%20Wedyra" style={{ display:"block", marginTop:16, textAlign:"center", padding:"10px", background:p.rec?C.primary:"transparent", color:p.rec?"#fff":C.primary, border:`1px solid ${C.primary}`, borderRadius:10, fontWeight:600, fontSize:13, textDecoration:"none" }}>Choisir</a>
            </div>
          ))}
        </div>
        <p style={{ fontSize:12, color:C.textLight, marginBottom:16 }}>Paiement sécurisé · Sans engagement · Résiliable à tout moment</p>
        <button onClick={()=>setTrialExpired(false)} style={{ fontSize:13, color:C.textLight, background:"none", border:"none", cursor:"pointer", textDecoration:"underline" }}>Continuer en mode lecture seule</button>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight:"100vh", background:C.page, fontFamily:"'DM Sans',sans-serif", color:C.text }}>
      <header style={{ background:C.header, borderBottom:`1px solid ${C.headerBorder}`, position:"sticky", top:0, zIndex:10 }}>
        <div style={{ maxWidth:1100, margin:"0 auto", height:"var(--header-height)", padding:"0 var(--header-padding-x)", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <div className="header-left">
            <button className="logo-link"><Logo height={96} dark={dark}/></button>
            <span style={{fontSize:11,background:C.amberBg,color:C.amber,padding:"2px 8px",borderRadius:100,fontWeight:600,marginLeft:8}}>PRO</span>
            {trialInfo && !trialInfo.isPaid && (
              <span style={{ fontSize:10, background:trialInfo.daysLeft > 3 ? C.amberBg : "#FEE2E2", color:trialInfo.daysLeft > 3 ? C.amber : "#DC2626", padding:"2px 8px", borderRadius:100, fontWeight:600, marginLeft:4, cursor:"pointer" }} onClick={()=>setShowPricing(true)}>
                Essai · {trialInfo.daysLeft}j
              </span>
            )}
          </div>
          <div className="header-right">
            <div className="icon-btn" onClick={()=>setDark(!dark)} style={{gap:6}}>
              <span style={{fontSize:13}}>{dark?"🌙":"☀️"}</span>
              <div style={{ width:34, height:20, borderRadius:100, background:dark?C.primary:C.cardBorder, display:"flex", alignItems:"center", padding:"2px" }}><div style={{ width:16, height:16, borderRadius:"50%", background:"#fff", transform:dark?"translateX(14px)":"translateX(0)", transition:"transform 0.3s" }}/></div>
            </div>
            <div className="pill-btn">🏢 {user.nom}</div>
            <button className="text-btn logout-btn" onClick={onLogout} style={{color:C.textLight, whiteSpace:"nowrap", flexShrink:0}}>Déconnexion</button>
          </div>
        </div>
      </header>
      {trialInfo && !trialInfo.isPaid && !trialExpired && (
        <div style={{ background:trialInfo.daysLeft > 3 ? C.amberBg : "#FEE2E2", borderBottom:`1px solid ${trialInfo.daysLeft > 3 ? "#E8D4B0" : "#FCA5A5"}`, padding:"10px 32px", display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:8, fontSize:13 }}>
          <span style={{ color:trialInfo.daysLeft > 3 ? C.amber : "#DC2626", fontWeight:600 }}>
            {trialInfo.daysLeft > 0 ? `⏳ Essai gratuit — ${trialInfo.daysLeft} jour${trialInfo.daysLeft>1?"s":""} restant${trialInfo.daysLeft>1?"s":""}` : "⚠️ Votre essai se termine aujourd'hui"}
          </span>
          <button onClick={()=>setShowPricing(true)} style={{ padding:"6px 16px", background:C.primary, color:"#fff", border:"none", borderRadius:8, fontSize:12, fontWeight:600, cursor:"pointer" }}>Voir les offres</button>
        </div>
      )}
      <div className="dash-container">
        <div style={{marginBottom:32}}><h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:"clamp(26px,3vw,36px)", fontWeight:400, color:C.text, marginBottom:6 }}>Bienvenue, <em style={{color:C.primary}}>{user.nom}</em></h1><p style={{ fontSize:14, color:C.textLight }}>Espace prestataire</p></div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))", gap:14, marginBottom:28 }}>
          {[
            {l:"Vues profil",v:stats?.totalViews??"—",e:"👁️",c:C.primary,sub:stats?.weekViews!=null?`+${stats.weekViews} cette semaine`:null},
            {l:"Demandes",v:demandes.length,e:"📩",c:C.primary},
            {l:"En attente",v:demandes.filter(d=>d.statut==="envoyee").length,e:"⏳",c:C.amber},
            {l:"Acceptées",v:demandes.filter(d=>d.statut==="acceptee").length,e:"✅",c:C.green},
            {l:"Taux contact",v:stats?.contactRate!=null?`${stats.contactRate}%`:"—",e:"📊",c:C.primary},
          ].map((s,i)=>(
            <div key={i} style={{background:C.card,borderRadius:16,padding:"20px 22px",border:`1px solid ${C.cardBorder}`,display:"flex",alignItems:"center",gap:16}}>
              <div style={{width:48,height:48,borderRadius:14,background:C.primaryBg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22}}>{s.e}</div>
              <div>
                <div style={{fontSize:11,color:C.textLight,letterSpacing:"1px",textTransform:"uppercase",fontWeight:600}}>{s.l}</div>
                <div style={{fontFamily:"'Playfair Display',serif",fontSize:28,color:s.c,marginTop:4}}>{s.v}</div>
                {s.sub&&<div style={{fontSize:11,color:C.green,marginTop:2}}>{s.sub}</div>}
              </div>
            </div>
          ))}
        </div>
        <div className="tabs-scroll" style={{ display:"flex", gap:4, marginBottom:22, background:C.primaryBg, borderRadius:100, padding:4, width:"100%", overflowX:"auto", WebkitOverflowScrolling:"touch" }}>
          {TABS.map((t,i)=><button key={t} onClick={()=>setTab(i)} style={{ padding:"8px 16px", borderRadius:100, border:"none", cursor:"pointer", fontSize:13, fontWeight:500, background:tab===i?C.primary:"transparent", color:tab===i?"#fff":C.textMuted, flexShrink:0, whiteSpace:"nowrap", position:"relative" }}>
            {t}
            {t.includes("Messages") && chatUnread > 0 && tab!==i && <span style={{ position:"absolute", top:2, right:2, minWidth:16, height:16, borderRadius:"50%", background:"#E53935", color:"#fff", fontSize:9, fontWeight:700, display:"flex", alignItems:"center", justifyContent:"center", padding:"0 3px" }}>{chatUnread > 9 ? "9+" : chatUnread}</span>}
          </button>)}
        </div>

        {tab===0&&<div className="fade-in">
          <div style={{...card,background:C.primaryBg,border:`1px solid ${C.primaryBorder}`}}><div style={{fontSize:11,color:C.primary,letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:8,fontWeight:600}}>🏢 Visibilité</div><p style={{fontSize:14,color:C.text,lineHeight:1.7}}>Votre profil est visible. Plus il est complet, plus vous recevez de demandes.</p></div>
          {stats&&<div style={card}>
            <div style={{fontSize:11,color:C.textLight,letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:16,fontWeight:600}}>📊 Statistiques</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              {[
                {l:"Vues totales",v:stats.totalViews},
                {l:"Vues cette semaine",v:stats.weekViews},
                {l:"Demandes reçues",v:demandes.length},
                {l:"Taux d'acceptation",v:`${stats.contactRate}%`},
              ].map((r,i)=>(
                <div key={i} style={{background:C.page,borderRadius:12,padding:"14px 16px",border:`1px solid ${C.cardBorder}`}}>
                  <div style={{fontSize:11,color:C.textLight,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:4}}>{r.l}</div>
                  <div style={{fontFamily:"'Playfair Display',serif",fontSize:24,color:C.text}}>{r.v}</div>
                </div>
              ))}
            </div>
          </div>}
          {demandes.length>0?<div style={card}><div style={{fontSize:11,color:C.textLight,letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:18,fontWeight:600}}>Dernières demandes</div>
            {demandes.slice(0,3).map((d,i)=><div key={i} style={{display:"flex",alignItems:"center",gap:14,padding:"12px 0",borderBottom:`1px solid ${C.cardBorder}`}}>
              <div style={{width:42,height:42,borderRadius:"50%",background:C.primaryBg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}}>💒</div>
              <div style={{flex:1}}><div style={{fontSize:14,fontWeight:600,color:C.text}}>{d.couples?.prenom1} & {d.couples?.prenom2}</div><div style={{fontSize:12,color:C.textLight}}>{d.couples?.ville||"—"}</div></div>
              <span style={{fontSize:11,padding:"3px 10px",borderRadius:100,fontWeight:600,background:d.statut==="envoyee"?C.amberBg:C.greenBg,color:d.statut==="envoyee"?C.amber:C.green}}>{d.statut==="envoyee"?"Nouvelle":"Acceptée"}</span>
            </div>)}
          </div>:<div style={{...card,textAlign:"center",padding:"40px"}}><div style={{fontSize:32,marginBottom:12}}>📩</div><p style={{color:C.textLight}}>Aucune demande pour l'instant.</p></div>}
        </div>}

        {tab===1&&<div className="fade-in">
          {demandes.length===0?<div style={{...card,textAlign:"center",padding:"60px"}}><div style={{fontSize:40,marginBottom:16}}>📩</div><p style={{color:C.textLight}}>Les couples vous contacteront via le matching.</p></div>
          :<div style={card}>{demandes.map((d,i)=><div key={i} style={{padding:"16px 0",borderBottom:`1px solid ${C.cardBorder}`}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
              <div><div style={{fontFamily:"'Playfair Display',serif",fontSize:18,color:C.text}}>{d.couples?.prenom1} & {d.couples?.prenom2}</div><div style={{fontSize:12,color:C.textLight,marginTop:2}}>{d.couples?.email} · {d.couples?.ville}</div></div>
              <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                {d.couples?.email && <a href={`mailto:${d.couples.email}`} style={{padding:"6px 14px",background:C.blueBg,color:C.blue,border:`1px solid ${C.blue}`,borderRadius:8,fontSize:12,fontWeight:600,textDecoration:"none"}}>✉️ Email</a>}
                <button onClick={async()=>{await supabase.from("demandes_contact").update({statut:"acceptee"}).eq("id",d.id);setDemandes(ds=>ds.map(x=>x.id===d.id?{...x,statut:"acceptee"}:x));}} style={{padding:"6px 14px",background:C.green,color:"#fff",border:"none",borderRadius:8,fontSize:12,fontWeight:600,cursor:"pointer"}}>Accepter</button>
                <button onClick={async()=>{await supabase.from("demandes_contact").update({statut:"refusee"}).eq("id",d.id);setDemandes(ds=>ds.filter(x=>x.id!==d.id));}} style={{padding:"6px 14px",background:"transparent",border:`1px solid ${C.cardBorder}`,borderRadius:8,fontSize:12,color:C.textMuted,cursor:"pointer"}}>Refuser</button>
              </div>
            </div>
            <div style={{fontSize:13,color:C.textMuted,background:C.notesBg,padding:"10px 14px",borderRadius:10}}>{d.message}</div>
          </div>)}</div>}
        </div>}

        {tab===2&&<div className="fade-in"><Chat user={user} C={C} onUnreadChange={setChatUnread}/></div>}

        {tab===3&&<div className="fade-in"><ProAvis user={user} C={C}/></div>}

        {tab===4&&<div className="fade-in" style={card}>
  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
    <div style={{fontFamily:"'Playfair Display',serif",fontSize:22,color:C.text}}>Mon profil</div>
    <div style={{display:"flex",gap:8,alignItems:"center"}}>
      {saved&&<span style={{fontSize:12,color:C.green,fontWeight:600}}>✓ Enregistré</span>}
      {!editMode
        ? <button onClick={()=>setEditMode(true)} style={{padding:"8px 16px",background:C.primary,color:"#fff",border:"none",borderRadius:10,fontSize:13,fontWeight:600,cursor:"pointer"}}>✏️ Modifier</button>
        : <div style={{display:"flex",gap:8}}>
            <button onClick={saveProfile} disabled={saving} style={{padding:"8px 16px",background:C.green,color:"#fff",border:"none",borderRadius:10,fontSize:13,fontWeight:600,cursor:"pointer"}}>{saving?"Enregistrement...":"✓ Enregistrer"}</button>
            <button onClick={()=>setEditMode(false)} style={{padding:"8px 16px",background:"transparent",border:`1px solid ${C.cardBorder}`,borderRadius:10,fontSize:13,color:C.textMuted,cursor:"pointer"}}>Annuler</button>
          </div>
      }
    </div>
  </div>
  {editMode ? (
    <div style={{display:"grid",gap:16}}>
      <div>
        <div style={{fontSize:12,fontWeight:600,color:C.text,marginBottom:5}}>Nom de l'entreprise</div>
        <input value={proForm.nom_entreprise} onChange={e=>setProForm(f=>({...f,nom_entreprise:e.target.value}))}
          style={{width:"100%",padding:"11px 14px",borderRadius:10,border:`1.5px solid ${C.cardBorder}`,background:C.card,color:C.text,fontSize:14,outline:"none",boxSizing:"border-box"}}
          onFocus={e=>e.target.style.borderColor=C.primary} onBlur={e=>e.target.style.borderColor=C.cardBorder}/>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <div>
          <div style={{fontSize:12,fontWeight:600,color:C.text,marginBottom:5}}>Ville</div>
          <input value={proForm.ville} onChange={e=>setProForm(f=>({...f,ville:e.target.value}))} placeholder="Strasbourg"
            style={{width:"100%",padding:"11px 14px",borderRadius:10,border:`1.5px solid ${C.cardBorder}`,background:C.card,color:C.text,fontSize:14,outline:"none",boxSizing:"border-box"}}/>
        </div>
        <div>
          <div style={{fontSize:12,fontWeight:600,color:C.text,marginBottom:5}}>Téléphone</div>
          <input value={proForm.telephone} onChange={e=>setProForm(f=>({...f,telephone:e.target.value}))} placeholder="06..."
            style={{width:"100%",padding:"11px 14px",borderRadius:10,border:`1.5px solid ${C.cardBorder}`,background:C.card,color:C.text,fontSize:14,outline:"none",boxSizing:"border-box"}}/>
        </div>
      </div>
      <div>
        <div style={{fontSize:12,fontWeight:600,color:C.text,marginBottom:5}}>Description <span style={{fontWeight:400,color:C.textLight}}>({proForm.description.length}/500)</span></div>
        <textarea value={proForm.description} onChange={e=>setProForm(f=>({...f,description:e.target.value.slice(0,500)}))} placeholder="Décrivez vos services, votre expérience, votre style..."
          style={{width:"100%",padding:"12px 14px",borderRadius:10,border:`1.5px solid ${C.cardBorder}`,background:C.card,color:C.text,fontSize:14,outline:"none",resize:"vertical",minHeight:100,boxSizing:"border-box",lineHeight:1.6}}/>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <div>
          <div style={{fontSize:12,fontWeight:600,color:C.text,marginBottom:5}}>Site web</div>
          <input value={proForm.site_web} onChange={e=>setProForm(f=>({...f,site_web:e.target.value}))} placeholder="https://www.monsite.fr"
            style={{width:"100%",padding:"11px 14px",borderRadius:10,border:`1.5px solid ${C.cardBorder}`,background:C.card,color:C.text,fontSize:14,outline:"none",boxSizing:"border-box"}}/>
        </div>
        <div>
          <div style={{fontSize:12,fontWeight:600,color:C.text,marginBottom:5}}>Instagram</div>
          <input value={proForm.instagram} onChange={e=>setProForm(f=>({...f,instagram:e.target.value}))} placeholder="@moncompte"
            style={{width:"100%",padding:"11px 14px",borderRadius:10,border:`1.5px solid ${C.cardBorder}`,background:C.card,color:C.text,fontSize:14,outline:"none",boxSizing:"border-box"}}/>
        </div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12}}>
        <div>
          <div style={{fontSize:12,fontWeight:600,color:C.text,marginBottom:5}}>Prix min (€)</div>
          <input type="number" value={proForm.prix_min} onChange={e=>setProForm(f=>({...f,prix_min:e.target.value}))} placeholder="500"
            style={{width:"100%",padding:"11px 14px",borderRadius:10,border:`1.5px solid ${C.cardBorder}`,background:C.card,color:C.text,fontSize:14,outline:"none",boxSizing:"border-box"}}/>
        </div>
        <div>
          <div style={{fontSize:12,fontWeight:600,color:C.text,marginBottom:5}}>Prix max (€)</div>
          <input type="number" value={proForm.prix_max} onChange={e=>setProForm(f=>({...f,prix_max:e.target.value}))} placeholder="3000"
            style={{width:"100%",padding:"11px 14px",borderRadius:10,border:`1.5px solid ${C.cardBorder}`,background:C.card,color:C.text,fontSize:14,outline:"none",boxSizing:"border-box"}}/>
        </div>
        <div>
          <div style={{fontSize:12,fontWeight:600,color:C.text,marginBottom:5}}>Zone (km)</div>
          <input type="number" value={proForm.rayon_intervention_km} onChange={e=>setProForm(f=>({...f,rayon_intervention_km:e.target.value}))} placeholder="50"
            style={{width:"100%",padding:"11px 14px",borderRadius:10,border:`1.5px solid ${C.cardBorder}`,background:C.card,color:C.text,fontSize:14,outline:"none",boxSizing:"border-box"}}/>
        </div>
      </div>
      <div style={{fontSize:12,color:C.textLight,fontStyle:"italic"}}>Email : {proForm.email} (non modifiable)</div>
    </div>
  ) : (
    <div style={{display:"grid",gap:0}}>
      {[
        {l:"Entreprise",v:proForm.nom_entreprise||"—",icon:"🏢"},
        {l:"Email",v:proForm.email||"—",icon:"✉️"},
        {l:"Ville",v:proForm.ville||"—",icon:"📍"},
        {l:"Téléphone",v:proForm.telephone||"—",icon:"📞"},
        {l:"Description",v:proForm.description||"Aucune description",icon:"📝"},
        {l:"Site web",v:proForm.site_web||"—",icon:"🌐"},
        {l:"Instagram",v:proForm.instagram||"—",icon:"📸"},
        {l:"Tarifs",v:proForm.prix_min&&proForm.prix_max?`${proForm.prix_min}€ – ${proForm.prix_max}€`:"Non renseigné",icon:"💰"},
        {l:"Zone intervention",v:proForm.rayon_intervention_km?`${proForm.rayon_intervention_km} km`:"Non renseigné",icon:"🗺️"},
        {l:"Note moyenne",v:proData.note_moyenne?`${proData.note_moyenne}/5 (${proData.nb_avis||0} avis)`:"Pas encore d'avis",icon:"⭐"},
      ].map((f,i)=>(
        <div key={i} style={{display:"flex",alignItems:"flex-start",gap:12,padding:"14px 0",borderBottom:`1px solid ${C.cardBorder}`}}>
          <span style={{fontSize:16,flexShrink:0,marginTop:1}}>{f.icon}</span>
          <div style={{flex:1}}>
            <div style={{fontSize:11,color:C.textLight,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:3}}>{f.l}</div>
            <div style={{fontSize:14,color:C.text,fontWeight:500,lineHeight:1.5}}>{f.v}</div>
          </div>
        </div>
      ))}
    </div>
  )}
</div>}
      </div>

      {showPricing && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={()=>setShowPricing(false)}>
          <div style={{ background:C.card, borderRadius:24, padding:32, maxWidth:660, width:"100%", maxHeight:"90vh", overflowY:"auto" }} onClick={e=>e.stopPropagation()}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24 }}>
              <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:28, fontWeight:400, color:C.text }}>Nos offres</h2>
              <button onClick={()=>setShowPricing(false)} style={{ background:"none", border:"none", fontSize:24, cursor:"pointer", color:C.textLight, lineHeight:1 }}>×</button>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))", gap:16, marginBottom:20 }}>
              {[
                {plan:"Essentiel",price:"29€/mois",features:["Profil visible","Demandes illimitées","Messagerie"]},
                {plan:"Premium",price:"49€/mois",features:["Tout Essentiel","Mise en avant","Statistiques","Support prioritaire"],rec:true},
                {plan:"Élite",price:"79€/mois",features:["Tout Premium","Badge Élite","Nouvelles fonctions en avant-première"]},
              ].map((p,i)=>(
                <div key={i} style={{ background:C.page, border:`2px solid ${p.rec?C.primary:C.cardBorder}`, borderRadius:18, padding:"24px 20px", position:"relative" }}>
                  {p.rec && <div style={{ position:"absolute", top:-11, left:"50%", transform:"translateX(-50%)", background:C.primary, color:"#fff", fontSize:10, padding:"3px 12px", borderRadius:100, fontWeight:600, whiteSpace:"nowrap" }}>Recommandé</div>}
                  <div style={{ fontSize:17, fontWeight:600, color:C.text, marginBottom:8 }}>{p.plan}</div>
                  <div style={{ fontFamily:"'Playfair Display',serif", fontSize:26, color:C.primary, marginBottom:12 }}>{p.price}</div>
                  <ul style={{ listStyle:"none", padding:0 }}>
                    {p.features.map((f,j)=><li key={j} style={{ fontSize:13, color:C.textLight, marginBottom:6 }}>✓ {f}</li>)}
                  </ul>
                  <a href="mailto:contact@wedyra.fr?subject=Abonnement%20Wedyra" style={{ display:"block", marginTop:16, textAlign:"center", padding:"10px", background:p.rec?C.primary:"transparent", color:p.rec?"#fff":C.primary, border:`1px solid ${C.primary}`, borderRadius:10, fontWeight:600, fontSize:13, textDecoration:"none" }}>Choisir</a>
                </div>
              ))}
            </div>
            <p style={{ fontSize:12, color:C.textLight, textAlign:"center" }}>Paiement sécurisé · Sans engagement · Résiliable à tout moment · <a href="/conditions-tarifaires" style={{ color:C.primary }}>Conditions tarifaires</a></p>
          </div>
        </div>
      )}
    </div>
  );
}

// DEMO DATA
const DEMO_MATCH = [
  {id:"d1",nom_entreprise:"Studio Lumière",ville:"Strasbourg",description:"Photographe mariage, 200+ mariages. Reportage naturel et émotionnel.",note_moyenne:4.9,nb_avis:87,score:95,matchCats:["Photographe"],is_premium:true,prix_min:1200,prix_max:3500},
  {id:"d2",nom_entreprise:"DJ Max Events",ville:"Haguenau",description:"DJ pro, 10 ans d'expérience. Sono HD, éclairages. Bilingue FR/DE.",note_moyenne:4.7,nb_avis:45,score:88,matchCats:["DJ / Musique"],is_premium:false,prix_min:600,prix_max:1500},
  {id:"d3",nom_entreprise:"Fleurs d'Émotion",ville:"Obernai",description:"Fleuriste créative, bouquets et arches sur mesure.",note_moyenne:4.9,nb_avis:38,score:85,matchCats:["Fleuriste"],is_premium:false,prix_min:800,prix_max:4000},
  {id:"d4",nom_entreprise:"Le Palais Gourmand",ville:"Strasbourg",description:"Traiteur gastronomique, tradition alsacienne et modernité.",note_moyenne:4.6,nb_avis:54,score:82,matchCats:["Traiteur"],is_premium:true,prix_min:45,prix_max:120},
];